/* tslint:disable */
/* eslint-disable */
/**
 * MIT Learn API
 * MIT public API
 *
 * The version of the OpenAPI document: 0.0.1 (v1)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, operationServerMap } from './base';
/**
 * * `resource_type` - resource_type * `certification` - certification * `certification_type` - certification_type * `offered_by` - offered_by * `platform` - platform * `topic` - topic * `department` - department * `level` - level * `course_feature` - course_feature * `professional` - professional * `free` - free * `delivery` - delivery * `resource_category` - resource_category
 * @export
 * @enum {string}
 */
export const AggregationsEnum = {
    /**
    * resource_type
    */
    ResourceType: 'resource_type',
    /**
    * certification
    */
    Certification: 'certification',
    /**
    * certification_type
    */
    CertificationType: 'certification_type',
    /**
    * offered_by
    */
    OfferedBy: 'offered_by',
    /**
    * platform
    */
    Platform: 'platform',
    /**
    * topic
    */
    Topic: 'topic',
    /**
    * department
    */
    Department: 'department',
    /**
    * level
    */
    Level: 'level',
    /**
    * course_feature
    */
    CourseFeature: 'course_feature',
    /**
    * professional
    */
    Professional: 'professional',
    /**
    * free
    */
    Free: 'free',
    /**
    * delivery
    */
    Delivery: 'delivery',
    /**
    * resource_category
    */
    ResourceCategory: 'resource_category'
};
/**
 * * `dated` - Dated * `anytime` - Anytime
 * @export
 * @enum {string}
 */
export const AvailabilityEnum = {
    /**
    * Dated
    */
    Dated: 'dated',
    /**
    * Anytime
    */
    Anytime: 'anytime'
};
/**
 * * `micromasters` - MicroMasters Credential * `professional` - Professional Certificate * `completion` - Certificate of Completion * `none` - No Certificate
 * @export
 * @enum {string}
 */
export const CertificationTypeEnum = {
    /**
    * MicroMasters Credential
    */
    Micromasters: 'micromasters',
    /**
    * Professional Certificate
    */
    Professional: 'professional',
    /**
    * Certificate of Completion
    */
    Completion: 'completion',
    /**
    * No Certificate
    */
    None: 'none'
};
/**
 * * `page` - page * `file` - file * `video` - video * `pdf` - pdf
 * @export
 * @enum {string}
 */
export const ContentTypeEnum = {
    /**
    * page
    */
    Page: 'page',
    /**
    * file
    */
    File: 'file',
    /**
    * video
    */
    Video: 'video',
    /**
    * pdf
    */
    Pdf: 'pdf'
};
export const CourseResourceCertificationTypeCodeEnum = {
    Micromasters: 'micromasters',
    Professional: 'professional',
    Completion: 'completion',
    None: 'none'
};
export const CourseResourceDeliveryInnerCodeEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
export const CourseResourceFormatInnerCodeEnum = {
    Synchronous: 'synchronous',
    Asynchronous: 'asynchronous'
};
export const CourseResourcePaceInnerCodeEnum = {
    SelfPaced: 'self_paced',
    InstructorPaced: 'instructor_paced'
};
/**
 *
 * @export
 * @enum {string}
 */
export const CourseResourceResourceTypeEnum = {
    Course: 'course'
};
/**
 * * `online` - Online * `hybrid` - Hybrid * `in_person` - In person * `offline` - Offline
 * @export
 * @enum {string}
 */
export const DeliveryEnum = {
    /**
    * Online
    */
    Online: 'online',
    /**
    * Hybrid
    */
    Hybrid: 'hybrid',
    /**
    * In person
    */
    InPerson: 'in_person',
    /**
    * Offline
    */
    Offline: 'offline'
};
/**
 * * `1` - Civil and Environmental Engineering * `2` - Mechanical Engineering * `3` - Materials Science and Engineering * `4` - Architecture * `5` - Chemistry * `6` - Electrical Engineering and Computer Science * `7` - Biology * `8` - Physics * `9` - Brain and Cognitive Sciences * `10` - Chemical Engineering * `11` - Urban Studies and Planning * `12` - Earth, Atmospheric, and Planetary Sciences * `14` - Economics * `15` - Management * `16` - Aeronautics and Astronautics * `17` - Political Science * `18` - Mathematics * `20` - Biological Engineering * `21A` - Anthropology * `21G` - Global Languages * `21H` - History * `21L` - Literature * `21M` - Music and Theater Arts * `22` - Nuclear Science and Engineering * `24` - Linguistics and Philosophy * `CC` - Concourse * `CMS-W` - Comparative Media Studies/Writing * `EC` - Edgerton Center * `ES` - Experimental Study Group * `ESD` - Engineering Systems Division * `HST` - Medical Engineering and Science * `IDS` - Data, Systems, and Society * `MAS` - Media Arts and Sciences * `PE` - Athletics, Physical Education and Recreation * `SP` - Special Programs * `STS` - Science, Technology, and Society * `WGS` - Women\'s and Gender Studies
 * @export
 * @enum {string}
 */
export const DepartmentEnum = {
    /**
    * Civil and Environmental Engineering
    */
    _1: '1',
    /**
    * Mechanical Engineering
    */
    _2: '2',
    /**
    * Materials Science and Engineering
    */
    _3: '3',
    /**
    * Architecture
    */
    _4: '4',
    /**
    * Chemistry
    */
    _5: '5',
    /**
    * Electrical Engineering and Computer Science
    */
    _6: '6',
    /**
    * Biology
    */
    _7: '7',
    /**
    * Physics
    */
    _8: '8',
    /**
    * Brain and Cognitive Sciences
    */
    _9: '9',
    /**
    * Chemical Engineering
    */
    _10: '10',
    /**
    * Urban Studies and Planning
    */
    _11: '11',
    /**
    * Earth, Atmospheric, and Planetary Sciences
    */
    _12: '12',
    /**
    * Economics
    */
    _14: '14',
    /**
    * Management
    */
    _15: '15',
    /**
    * Aeronautics and Astronautics
    */
    _16: '16',
    /**
    * Political Science
    */
    _17: '17',
    /**
    * Mathematics
    */
    _18: '18',
    /**
    * Biological Engineering
    */
    _20: '20',
    /**
    * Anthropology
    */
    _21A: '21A',
    /**
    * Global Languages
    */
    _21G: '21G',
    /**
    * History
    */
    _21H: '21H',
    /**
    * Literature
    */
    _21L: '21L',
    /**
    * Music and Theater Arts
    */
    _21M: '21M',
    /**
    * Nuclear Science and Engineering
    */
    _22: '22',
    /**
    * Linguistics and Philosophy
    */
    _24: '24',
    /**
    * Concourse
    */
    Cc: 'CC',
    /**
    * Comparative Media Studies/Writing
    */
    CmsW: 'CMS-W',
    /**
    * Edgerton Center
    */
    Ec: 'EC',
    /**
    * Experimental Study Group
    */
    Es: 'ES',
    /**
    * Engineering Systems Division
    */
    Esd: 'ESD',
    /**
    * Medical Engineering and Science
    */
    Hst: 'HST',
    /**
    * Data, Systems, and Society
    */
    Ids: 'IDS',
    /**
    * Media Arts and Sciences
    */
    Mas: 'MAS',
    /**
    * Athletics, Physical Education and Recreation
    */
    Pe: 'PE',
    /**
    * Special Programs
    */
    Sp: 'SP',
    /**
    * Science, Technology, and Society
    */
    Sts: 'STS',
    /**
    * Women&#39;s and Gender Studies
    */
    Wgs: 'WGS'
};
/**
 *
 * @export
 * @enum {string}
 */
export const LearningPathResourceResourceTypeEnum = {
    LearningPath: 'learning_path'
};
export const LearningResourceRunLevelInnerCodeEnum = {
    Undergraduate: 'undergraduate',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Noncredit: 'noncredit',
    Advanced: 'advanced',
    Intermediate: 'intermediate',
    Introductory: 'introductory'
};
/**
 * * `undergraduate` - Undergraduate * `graduate` - Graduate * `high_school` - High School * `noncredit` - Non-Credit * `advanced` - Advanced * `intermediate` - Intermediate * `introductory` - Introductory
 * @export
 * @enum {string}
 */
export const LevelEnum = {
    /**
    * Undergraduate
    */
    Undergraduate: 'undergraduate',
    /**
    * Graduate
    */
    Graduate: 'graduate',
    /**
    * High School
    */
    HighSchool: 'high_school',
    /**
    * Non-Credit
    */
    Noncredit: 'noncredit',
    /**
    * Advanced
    */
    Advanced: 'advanced',
    /**
    * Intermediate
    */
    Intermediate: 'intermediate',
    /**
    * Introductory
    */
    Introductory: 'introductory'
};
/**
 *
 * @export
 * @enum {string}
 */
export const NullEnum = {
    Null: 'null'
};
/**
 * * `mitx` - MITx * `ocw` - MIT OpenCourseWare * `bootcamps` - Bootcamps * `xpro` - MIT xPRO * `mitpe` - MIT Professional Education * `see` - MIT Sloan Executive Education
 * @export
 * @enum {string}
 */
export const OfferedByEnum = {
    /**
    * MITx
    */
    Mitx: 'mitx',
    /**
    * MIT OpenCourseWare
    */
    Ocw: 'ocw',
    /**
    * Bootcamps
    */
    Bootcamps: 'bootcamps',
    /**
    * MIT xPRO
    */
    Xpro: 'xpro',
    /**
    * MIT Professional Education
    */
    Mitpe: 'mitpe',
    /**
    * MIT Sloan Executive Education
    */
    See: 'see'
};
/**
 * * `course` - course * `program` - program * `learning_path` - learning path * `podcast` - podcast * `podcast_episode` - podcast episode * `video` - video * `video_playlist` - video playlist
 * @export
 * @enum {string}
 */
export const PercolateQuerySubscriptionRequestResourceTypeEnum = {
    /**
    * course
    */
    Course: 'course',
    /**
    * program
    */
    Program: 'program',
    /**
    * learning path
    */
    LearningPath: 'learning_path',
    /**
    * podcast
    */
    Podcast: 'podcast',
    /**
    * podcast episode
    */
    PodcastEpisode: 'podcast_episode',
    /**
    * video
    */
    Video: 'video',
    /**
    * video playlist
    */
    VideoPlaylist: 'video_playlist'
};
/**
 * * `edx` - edX * `ocw` - MIT OpenCourseWare * `oll` - Open Learning Library * `mitxonline` - MITx Online * `bootcamps` - Bootcamps * `xpro` - MIT xPRO * `csail` - CSAIL * `mitpe` - MIT Professional Education * `see` - MIT Sloan Executive Education * `scc` - Schwarzman College of Computing * `ctl` - Center for Transportation & Logistics * `whu` - WHU * `susskind` - Susskind * `globalalumni` - Global Alumni * `simplilearn` - Simplilearn * `emeritus` - Emeritus * `podcast` - Podcast * `youtube` - YouTube
 * @export
 * @enum {string}
 */
export const PlatformEnum = {
    /**
    * edX
    */
    Edx: 'edx',
    /**
    * MIT OpenCourseWare
    */
    Ocw: 'ocw',
    /**
    * Open Learning Library
    */
    Oll: 'oll',
    /**
    * MITx Online
    */
    Mitxonline: 'mitxonline',
    /**
    * Bootcamps
    */
    Bootcamps: 'bootcamps',
    /**
    * MIT xPRO
    */
    Xpro: 'xpro',
    /**
    * CSAIL
    */
    Csail: 'csail',
    /**
    * MIT Professional Education
    */
    Mitpe: 'mitpe',
    /**
    * MIT Sloan Executive Education
    */
    See: 'see',
    /**
    * Schwarzman College of Computing
    */
    Scc: 'scc',
    /**
    * Center for Transportation &amp; Logistics
    */
    Ctl: 'ctl',
    /**
    * WHU
    */
    Whu: 'whu',
    /**
    * Susskind
    */
    Susskind: 'susskind',
    /**
    * Global Alumni
    */
    Globalalumni: 'globalalumni',
    /**
    * Simplilearn
    */
    Simplilearn: 'simplilearn',
    /**
    * Emeritus
    */
    Emeritus: 'emeritus',
    /**
    * Podcast
    */
    Podcast: 'podcast',
    /**
    * YouTube
    */
    Youtube: 'youtube'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PodcastEpisodeResourceResourceTypeEnum = {
    PodcastEpisode: 'podcast_episode'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PodcastResourceResourceTypeEnum = {
    Podcast: 'podcast'
};
/**
 * * `private` - private * `unlisted` - unlisted
 * @export
 * @enum {string}
 */
export const PrivacyLevelEnum = {
    /**
    * private
    */
    Private: 'private',
    /**
    * unlisted
    */
    Unlisted: 'unlisted'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ProgramResourceResourceTypeEnum = {
    Program: 'program'
};
/**
 * * `PROGRAM_COURSES` - Program Courses * `LEARNING_PATH_ITEMS` - Learning Path Items * `PODCAST_EPISODES` - Podcast Episodes * `PLAYLIST_VIDEOS` - Playlist Videos
 * @export
 * @enum {string}
 */
export const RelationTypeEnum = {
    /**
    * Program Courses
    */
    ProgramCourses: 'PROGRAM_COURSES',
    /**
    * Learning Path Items
    */
    LearningPathItems: 'LEARNING_PATH_ITEMS',
    /**
    * Podcast Episodes
    */
    PodcastEpisodes: 'PODCAST_EPISODES',
    /**
    * Playlist Videos
    */
    PlaylistVideos: 'PLAYLIST_VIDEOS'
};
/**
 * * `course` - Course * `program` - Program * `learning_material` - Learning Material
 * @export
 * @enum {string}
 */
export const ResourceCategoryEnum = {
    /**
    * Course
    */
    Course: 'course',
    /**
    * Program
    */
    Program: 'program',
    /**
    * Learning Material
    */
    LearningMaterial: 'learning_material'
};
/**
 * * `course` - course * `program` - program * `learning_path` - learning_path * `podcast` - podcast * `podcast_episode` - podcast_episode * `video` - video * `video_playlist` - video_playlist
 * @export
 * @enum {string}
 */
export const ResourceTypeEnum = {
    /**
    * course
    */
    Course: 'course',
    /**
    * program
    */
    Program: 'program',
    /**
    * learning_path
    */
    LearningPath: 'learning_path',
    /**
    * podcast
    */
    Podcast: 'podcast',
    /**
    * podcast_episode
    */
    PodcastEpisode: 'podcast_episode',
    /**
    * video
    */
    Video: 'video',
    /**
    * video_playlist
    */
    VideoPlaylist: 'video_playlist'
};
/**
 * * `best_fields` - best_fields * `most_fields` - most_fields * `phrase` - phrase  * `best_fields` - best_fields * `most_fields` - most_fields * `phrase` - phrase
 * @export
 * @enum {string}
 */
export const SearchModeEnum = {
    /**
    * best_fields
    */
    BestFields: 'best_fields',
    /**
    * most_fields
    */
    MostFields: 'most_fields',
    /**
    * phrase
    */
    Phrase: 'phrase'
};
/**
 * * `featured` - Featured * `id` - Object ID ascending * `-id` - Object ID descending * `readable_id` - Readable ID ascending * `-readable_id` - Readable ID descending * `last_modified` - Last Modified Date ascending * `-last_modified` - Last Modified Date descending * `new` - Newest resources first * `start_date` - Start Date ascending * `-start_date` - Start Date descending * `mitcoursenumber` - MIT course number ascending * `-mitcoursenumber` - MIT course number descending * `views` - Popularity ascending * `-views` - Popularity descending * `upcoming` - Next start date ascending
 * @export
 * @enum {string}
 */
export const SortbyEnum = {
    /**
    * Featured
    */
    Featured: 'featured',
    /**
    * Object ID ascending
    */
    Id: 'id',
    /**
    * Object ID descending
    */
    Id2: '-id',
    /**
    * Readable ID ascending
    */
    ReadableId: 'readable_id',
    /**
    * Readable ID descending
    */
    ReadableId2: '-readable_id',
    /**
    * Last Modified Date ascending
    */
    LastModified: 'last_modified',
    /**
    * Last Modified Date descending
    */
    LastModified2: '-last_modified',
    /**
    * Newest resources first
    */
    New: 'new',
    /**
    * Start Date ascending
    */
    StartDate: 'start_date',
    /**
    * Start Date descending
    */
    StartDate2: '-start_date',
    /**
    * MIT course number ascending
    */
    Mitcoursenumber: 'mitcoursenumber',
    /**
    * MIT course number descending
    */
    Mitcoursenumber2: '-mitcoursenumber',
    /**
    * Popularity ascending
    */
    Views: 'views',
    /**
    * Popularity descending
    */
    Views2: '-views',
    /**
    * Next start date ascending
    */
    Upcoming: 'upcoming'
};
/**
 * * `search_subscription_type` - search_subscription_type * `channel_subscription_type` - channel_subscription_type
 * @export
 * @enum {string}
 */
export const SourceTypeEnum = {
    /**
    * search_subscription_type
    */
    SearchSubscriptionType: 'search_subscription_type',
    /**
    * channel_subscription_type
    */
    ChannelSubscriptionType: 'channel_subscription_type'
};
/**
 *
 * @export
 * @enum {string}
 */
export const VideoPlaylistResourceResourceTypeEnum = {
    VideoPlaylist: 'video_playlist'
};
/**
 *
 * @export
 * @enum {string}
 */
export const VideoResourceResourceTypeEnum = {
    Video: 'video'
};
/**
 * ArticlesApi - axios parameter creator
 * @export
 */
export const ArticlesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a new article
         * @summary Create
         * @param {ArticleRequest} ArticleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesCreate: (ArticleRequest_1, ...args_1) => __awaiter(this, [ArticleRequest_1, ...args_1], void 0, function* (ArticleRequest, options = {}) {
            // verify required parameter 'ArticleRequest' is not null or undefined
            assertParamExists('articlesCreate', 'ArticleRequest', ArticleRequest);
            const localVarPath = `/api/v1/articles/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ArticleRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete an article
         * @summary Destroy
         * @param {number} id A unique integer value identifying this article.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesDestroy: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('articlesDestroy', 'id', id);
            const localVarPath = `/api/v1/articles/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a paginated list of articles
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesList: (limit_1, offset_1, ...args_3) => __awaiter(this, [limit_1, offset_1, ...args_3], void 0, function* (limit, offset, options = {}) {
            const localVarPath = `/api/v1/articles/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update an article
         * @summary Update
         * @param {number} id A unique integer value identifying this article.
         * @param {PatchedArticleRequest} [PatchedArticleRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesPartialUpdate: (id_2, PatchedArticleRequest_1, ...args_4) => __awaiter(this, [id_2, PatchedArticleRequest_1, ...args_4], void 0, function* (id, PatchedArticleRequest, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('articlesPartialUpdate', 'id', id);
            const localVarPath = `/api/v1/articles/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PatchedArticleRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a single article
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this article.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesRetrieve: (id_3, ...args_5) => __awaiter(this, [id_3, ...args_5], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('articlesRetrieve', 'id', id);
            const localVarPath = `/api/v1/articles/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ArticlesApi - functional programming interface
 * @export
 */
export const ArticlesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ArticlesApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a new article
         * @summary Create
         * @param {ArticleRequest} ArticleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesCreate(ArticleRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.articlesCreate(ArticleRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ArticlesApi.articlesCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Delete an article
         * @summary Destroy
         * @param {number} id A unique integer value identifying this article.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesDestroy(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.articlesDestroy(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ArticlesApi.articlesDestroy']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a paginated list of articles
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesList(limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.articlesList(limit, offset, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ArticlesApi.articlesList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Update an article
         * @summary Update
         * @param {number} id A unique integer value identifying this article.
         * @param {PatchedArticleRequest} [PatchedArticleRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesPartialUpdate(id, PatchedArticleRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.articlesPartialUpdate(id, PatchedArticleRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ArticlesApi.articlesPartialUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a single article
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this article.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.articlesRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ArticlesApi.articlesRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ArticlesApi - factory interface
 * @export
 */
export const ArticlesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ArticlesApiFp(configuration);
    return {
        /**
         * Create a new article
         * @summary Create
         * @param {ArticlesApiArticlesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesCreate(requestParameters, options) {
            return localVarFp.articlesCreate(requestParameters.ArticleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an article
         * @summary Destroy
         * @param {ArticlesApiArticlesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesDestroy(requestParameters, options) {
            return localVarFp.articlesDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a paginated list of articles
         * @summary List
         * @param {ArticlesApiArticlesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesList(requestParameters = {}, options) {
            return localVarFp.articlesList(requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an article
         * @summary Update
         * @param {ArticlesApiArticlesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesPartialUpdate(requestParameters, options) {
            return localVarFp.articlesPartialUpdate(requestParameters.id, requestParameters.PatchedArticleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single article
         * @summary Retrieve
         * @param {ArticlesApiArticlesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesRetrieve(requestParameters, options) {
            return localVarFp.articlesRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ArticlesApi - object-oriented interface
 * @export
 * @class ArticlesApi
 * @extends {BaseAPI}
 */
export class ArticlesApi extends BaseAPI {
    /**
     * Create a new article
     * @summary Create
     * @param {ArticlesApiArticlesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticlesApi
     */
    articlesCreate(requestParameters, options) {
        return ArticlesApiFp(this.configuration).articlesCreate(requestParameters.ArticleRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an article
     * @summary Destroy
     * @param {ArticlesApiArticlesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticlesApi
     */
    articlesDestroy(requestParameters, options) {
        return ArticlesApiFp(this.configuration).articlesDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a paginated list of articles
     * @summary List
     * @param {ArticlesApiArticlesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticlesApi
     */
    articlesList(requestParameters = {}, options) {
        return ArticlesApiFp(this.configuration).articlesList(requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update an article
     * @summary Update
     * @param {ArticlesApiArticlesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticlesApi
     */
    articlesPartialUpdate(requestParameters, options) {
        return ArticlesApiFp(this.configuration).articlesPartialUpdate(requestParameters.id, requestParameters.PatchedArticleRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single article
     * @summary Retrieve
     * @param {ArticlesApiArticlesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticlesApi
     */
    articlesRetrieve(requestParameters, options) {
        return ArticlesApiFp(this.configuration).articlesRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ContentFileSearchApi - axios parameter creator
 * @export
 */
export const ContentFileSearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Search for content files
         * @summary Search
         * @param {Array<ContentFileSearchRetrieveAggregationsEnum>} [aggregations] Show resource counts by category
         * @param {Array<string>} [content_feature_type] The feature type of the content file. Possible options are at api/v1/course_features/
         * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
         * @param {Array<number>} [id] The id value for the content file
         * @param {number} [limit] Number of results to return per page
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<ContentFileSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<ContentFileSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {string} [q] The search text
         * @param {Array<number>} [resource_id] The id value of the parent learning resource for the content file
         * @param {Array<number>} [run_id] The id value of the run that the content file belongs to
         * @param {ContentFileSearchRetrieveSortbyEnum} [sortby] if the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;id&#x60; - id * &#x60;-id&#x60; - -id * &#x60;resource_readable_id&#x60; - resource_readable_id * &#x60;-resource_readable_id&#x60; - -resource_readable_id
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentFileSearchRetrieve: (aggregations_1, content_feature_type_1, dev_mode_1, id_1, limit_1, ocw_topic_1, offered_by_1, offset_1, platform_1, q_1, resource_id_1, run_id_1, sortby_1, topic_1, ...args_1) => __awaiter(this, [aggregations_1, content_feature_type_1, dev_mode_1, id_1, limit_1, ocw_topic_1, offered_by_1, offset_1, platform_1, q_1, resource_id_1, run_id_1, sortby_1, topic_1, ...args_1], void 0, function* (aggregations, content_feature_type, dev_mode, id, limit, ocw_topic, offered_by, offset, platform, q, resource_id, run_id, sortby, topic, options = {}) {
            const localVarPath = `/api/v1/content_file_search/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aggregations) {
                localVarQueryParameter['aggregations'] = aggregations;
            }
            if (content_feature_type) {
                localVarQueryParameter['content_feature_type'] = content_feature_type;
            }
            if (dev_mode !== undefined) {
                localVarQueryParameter['dev_mode'] = dev_mode;
            }
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (ocw_topic) {
                localVarQueryParameter['ocw_topic'] = ocw_topic;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (resource_id) {
                localVarQueryParameter['resource_id'] = resource_id;
            }
            if (run_id) {
                localVarQueryParameter['run_id'] = run_id;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ContentFileSearchApi - functional programming interface
 * @export
 */
export const ContentFileSearchApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContentFileSearchApiAxiosParamCreator(configuration);
    return {
        /**
         * Search for content files
         * @summary Search
         * @param {Array<ContentFileSearchRetrieveAggregationsEnum>} [aggregations] Show resource counts by category
         * @param {Array<string>} [content_feature_type] The feature type of the content file. Possible options are at api/v1/course_features/
         * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
         * @param {Array<number>} [id] The id value for the content file
         * @param {number} [limit] Number of results to return per page
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<ContentFileSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<ContentFileSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {string} [q] The search text
         * @param {Array<number>} [resource_id] The id value of the parent learning resource for the content file
         * @param {Array<number>} [run_id] The id value of the run that the content file belongs to
         * @param {ContentFileSearchRetrieveSortbyEnum} [sortby] if the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;id&#x60; - id * &#x60;-id&#x60; - -id * &#x60;resource_readable_id&#x60; - resource_readable_id * &#x60;-resource_readable_id&#x60; - -resource_readable_id
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentFileSearchRetrieve(aggregations, content_feature_type, dev_mode, id, limit, ocw_topic, offered_by, offset, platform, q, resource_id, run_id, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.contentFileSearchRetrieve(aggregations, content_feature_type, dev_mode, id, limit, ocw_topic, offered_by, offset, platform, q, resource_id, run_id, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ContentFileSearchApi.contentFileSearchRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ContentFileSearchApi - factory interface
 * @export
 */
export const ContentFileSearchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContentFileSearchApiFp(configuration);
    return {
        /**
         * Search for content files
         * @summary Search
         * @param {ContentFileSearchApiContentFileSearchRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentFileSearchRetrieve(requestParameters = {}, options) {
            return localVarFp.contentFileSearchRetrieve(requestParameters.aggregations, requestParameters.content_feature_type, requestParameters.dev_mode, requestParameters.id, requestParameters.limit, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.q, requestParameters.resource_id, requestParameters.run_id, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContentFileSearchApi - object-oriented interface
 * @export
 * @class ContentFileSearchApi
 * @extends {BaseAPI}
 */
export class ContentFileSearchApi extends BaseAPI {
    /**
     * Search for content files
     * @summary Search
     * @param {ContentFileSearchApiContentFileSearchRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentFileSearchApi
     */
    contentFileSearchRetrieve(requestParameters = {}, options) {
        return ContentFileSearchApiFp(this.configuration).contentFileSearchRetrieve(requestParameters.aggregations, requestParameters.content_feature_type, requestParameters.dev_mode, requestParameters.id, requestParameters.limit, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.q, requestParameters.resource_id, requestParameters.run_id, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const ContentFileSearchRetrieveAggregationsEnum = {
    Topic: 'topic',
    ContentFeatureType: 'content_feature_type',
    Platform: 'platform',
    OfferedBy: 'offered_by'
};
/**
 * @export
 */
export const ContentFileSearchRetrieveOfferedByEnum = {
    Mitx: 'mitx',
    Ocw: 'ocw',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Mitpe: 'mitpe',
    See: 'see'
};
/**
 * @export
 */
export const ContentFileSearchRetrievePlatformEnum = {
    Edx: 'edx',
    Ocw: 'ocw',
    Oll: 'oll',
    Mitxonline: 'mitxonline',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Csail: 'csail',
    Mitpe: 'mitpe',
    See: 'see',
    Scc: 'scc',
    Ctl: 'ctl',
    Whu: 'whu',
    Susskind: 'susskind',
    Globalalumni: 'globalalumni',
    Simplilearn: 'simplilearn',
    Emeritus: 'emeritus',
    Podcast: 'podcast',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const ContentFileSearchRetrieveSortbyEnum = {
    Id: 'id',
    Id2: '-id',
    ResourceReadableId: 'resource_readable_id',
    ResourceReadableId2: '-resource_readable_id'
};
/**
 * ContentfilesApi - axios parameter creator
 * @export
 */
export const ContentfilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Viewset for ContentFiles
         * @summary List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {Array<string>} [content_feature_type] Multiple values may be separated by commas.
         * @param {Array<string>} [edx_module_id] Multiple values may be separated by commas.
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<ContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<ContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {Array<number>} [resource_id] Multiple values may be separated by commas.
         * @param {Array<number>} [run_id] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentfilesList: (learning_resource_id_1, content_feature_type_1, edx_module_id_1, limit_1, offered_by_1, offset_1, platform_1, resource_id_1, run_id_1, ...args_1) => __awaiter(this, [learning_resource_id_1, content_feature_type_1, edx_module_id_1, limit_1, offered_by_1, offset_1, platform_1, resource_id_1, run_id_1, ...args_1], void 0, function* (learning_resource_id, content_feature_type, edx_module_id, limit, offered_by, offset, platform, resource_id, run_id, options = {}) {
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('contentfilesList', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/contentfiles/`
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (content_feature_type) {
                localVarQueryParameter['content_feature_type'] = content_feature_type.join(COLLECTION_FORMATS.csv);
            }
            if (edx_module_id) {
                localVarQueryParameter['edx_module_id'] = edx_module_id.join(COLLECTION_FORMATS.csv);
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (resource_id) {
                localVarQueryParameter['resource_id'] = resource_id.join(COLLECTION_FORMATS.csv);
            }
            if (run_id) {
                localVarQueryParameter['run_id'] = run_id.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for ContentFiles
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this contentfile.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentfilesRetrieve: (id_1, learning_resource_id_2, ...args_2) => __awaiter(this, [id_1, learning_resource_id_2, ...args_2], void 0, function* (id, learning_resource_id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contentfilesRetrieve', 'id', id);
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('contentfilesRetrieve', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/contentfiles/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ContentfilesApi - functional programming interface
 * @export
 */
export const ContentfilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContentfilesApiAxiosParamCreator(configuration);
    return {
        /**
         * Viewset for ContentFiles
         * @summary List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {Array<string>} [content_feature_type] Multiple values may be separated by commas.
         * @param {Array<string>} [edx_module_id] Multiple values may be separated by commas.
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<ContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<ContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {Array<number>} [resource_id] Multiple values may be separated by commas.
         * @param {Array<number>} [run_id] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentfilesList(learning_resource_id, content_feature_type, edx_module_id, limit, offered_by, offset, platform, resource_id, run_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.contentfilesList(learning_resource_id, content_feature_type, edx_module_id, limit, offered_by, offset, platform, resource_id, run_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ContentfilesApi.contentfilesList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for ContentFiles
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this contentfile.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentfilesRetrieve(id, learning_resource_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.contentfilesRetrieve(id, learning_resource_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ContentfilesApi.contentfilesRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ContentfilesApi - factory interface
 * @export
 */
export const ContentfilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContentfilesApiFp(configuration);
    return {
        /**
         * Viewset for ContentFiles
         * @summary List
         * @param {ContentfilesApiContentfilesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentfilesList(requestParameters, options) {
            return localVarFp.contentfilesList(requestParameters.learning_resource_id, requestParameters.content_feature_type, requestParameters.edx_module_id, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.resource_id, requestParameters.run_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for ContentFiles
         * @summary Retrieve
         * @param {ContentfilesApiContentfilesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentfilesRetrieve(requestParameters, options) {
            return localVarFp.contentfilesRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContentfilesApi - object-oriented interface
 * @export
 * @class ContentfilesApi
 * @extends {BaseAPI}
 */
export class ContentfilesApi extends BaseAPI {
    /**
     * Viewset for ContentFiles
     * @summary List
     * @param {ContentfilesApiContentfilesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentfilesApi
     */
    contentfilesList(requestParameters, options) {
        return ContentfilesApiFp(this.configuration).contentfilesList(requestParameters.learning_resource_id, requestParameters.content_feature_type, requestParameters.edx_module_id, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.resource_id, requestParameters.run_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for ContentFiles
     * @summary Retrieve
     * @param {ContentfilesApiContentfilesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentfilesApi
     */
    contentfilesRetrieve(requestParameters, options) {
        return ContentfilesApiFp(this.configuration).contentfilesRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const ContentfilesListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const ContentfilesListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * CourseFeaturesApi - axios parameter creator
 * @export
 */
export const CourseFeaturesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Course Features and Content Feature Types
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseFeaturesList: (limit_1, offset_1, ...args_1) => __awaiter(this, [limit_1, offset_1, ...args_1], void 0, function* (limit, offset, options = {}) {
            const localVarPath = `/api/v1/course_features/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Course Features and Content Feature Types
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource content tag.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseFeaturesRetrieve: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseFeaturesRetrieve', 'id', id);
            const localVarPath = `/api/v1/course_features/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CourseFeaturesApi - functional programming interface
 * @export
 */
export const CourseFeaturesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CourseFeaturesApiAxiosParamCreator(configuration);
    return {
        /**
         * Course Features and Content Feature Types
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseFeaturesList(limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseFeaturesList(limit, offset, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['CourseFeaturesApi.courseFeaturesList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Course Features and Content Feature Types
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource content tag.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseFeaturesRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseFeaturesRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['CourseFeaturesApi.courseFeaturesRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * CourseFeaturesApi - factory interface
 * @export
 */
export const CourseFeaturesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CourseFeaturesApiFp(configuration);
    return {
        /**
         * Course Features and Content Feature Types
         * @summary List
         * @param {CourseFeaturesApiCourseFeaturesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseFeaturesList(requestParameters = {}, options) {
            return localVarFp.courseFeaturesList(requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Course Features and Content Feature Types
         * @summary Retrieve
         * @param {CourseFeaturesApiCourseFeaturesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseFeaturesRetrieve(requestParameters, options) {
            return localVarFp.courseFeaturesRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CourseFeaturesApi - object-oriented interface
 * @export
 * @class CourseFeaturesApi
 * @extends {BaseAPI}
 */
export class CourseFeaturesApi extends BaseAPI {
    /**
     * Course Features and Content Feature Types
     * @summary List
     * @param {CourseFeaturesApiCourseFeaturesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseFeaturesApi
     */
    courseFeaturesList(requestParameters = {}, options) {
        return CourseFeaturesApiFp(this.configuration).courseFeaturesList(requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Course Features and Content Feature Types
     * @summary Retrieve
     * @param {CourseFeaturesApiCourseFeaturesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseFeaturesApi
     */
    courseFeaturesRetrieve(requestParameters, options) {
        return CourseFeaturesApiFp(this.configuration).courseFeaturesRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CoursesApi - axios parameter creator
 * @export
 */
export const CoursesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {Array<string>} [content_feature_type] Multiple values may be separated by commas.
         * @param {Array<string>} [edx_module_id] Multiple values may be separated by commas.
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<CoursesContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<CoursesContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {Array<number>} [resource_id] Multiple values may be separated by commas.
         * @param {Array<number>} [run_id] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesContentfilesList: (learning_resource_id_1, content_feature_type_1, edx_module_id_1, limit_1, offered_by_1, offset_1, platform_1, resource_id_1, run_id_1, ...args_1) => __awaiter(this, [learning_resource_id_1, content_feature_type_1, edx_module_id_1, limit_1, offered_by_1, offset_1, platform_1, resource_id_1, run_id_1, ...args_1], void 0, function* (learning_resource_id, content_feature_type, edx_module_id, limit, offered_by, offset, platform, resource_id, run_id, options = {}) {
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('coursesContentfilesList', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/courses/{learning_resource_id}/contentfiles/`
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (content_feature_type) {
                localVarQueryParameter['content_feature_type'] = content_feature_type.join(COLLECTION_FORMATS.csv);
            }
            if (edx_module_id) {
                localVarQueryParameter['edx_module_id'] = edx_module_id.join(COLLECTION_FORMATS.csv);
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (resource_id) {
                localVarQueryParameter['resource_id'] = resource_id.join(COLLECTION_FORMATS.csv);
            }
            if (run_id) {
                localVarQueryParameter['run_id'] = run_id.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File Retrieve
         * @param {number} id A unique integer value identifying this contentfile.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesContentfilesRetrieve: (id_1, learning_resource_id_2, ...args_2) => __awaiter(this, [id_1, learning_resource_id_2, ...args_2], void 0, function* (id, learning_resource_id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('coursesContentfilesRetrieve', 'id', id);
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('coursesContentfilesRetrieve', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/courses/{learning_resource_id}/contentfiles/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a paginated list of courses
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<CoursesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<CoursesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<CoursesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<CoursesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<CoursesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<CoursesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<CoursesListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<CoursesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {CoursesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesList: (certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_2, offered_by_2, offset_2, platform_2, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_3) => __awaiter(this, [certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_2, offered_by_2, offset_2, platform_2, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_3], void 0, function* (certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            const localVarPath = `/api/v1/courses/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a single course
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesRetrieve: (id_2, ...args_4) => __awaiter(this, [id_2, ...args_4], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('coursesRetrieve', 'id', id);
            const localVarPath = `/api/v1/courses/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CoursesApi - functional programming interface
 * @export
 */
export const CoursesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CoursesApiAxiosParamCreator(configuration);
    return {
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {Array<string>} [content_feature_type] Multiple values may be separated by commas.
         * @param {Array<string>} [edx_module_id] Multiple values may be separated by commas.
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<CoursesContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<CoursesContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {Array<number>} [resource_id] Multiple values may be separated by commas.
         * @param {Array<number>} [run_id] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesContentfilesList(learning_resource_id, content_feature_type, edx_module_id, limit, offered_by, offset, platform, resource_id, run_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.coursesContentfilesList(learning_resource_id, content_feature_type, edx_module_id, limit, offered_by, offset, platform, resource_id, run_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['CoursesApi.coursesContentfilesList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File Retrieve
         * @param {number} id A unique integer value identifying this contentfile.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesContentfilesRetrieve(id, learning_resource_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.coursesContentfilesRetrieve(id, learning_resource_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['CoursesApi.coursesContentfilesRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a paginated list of courses
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<CoursesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<CoursesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<CoursesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<CoursesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<CoursesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<CoursesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<CoursesListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<CoursesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {CoursesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.coursesList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['CoursesApi.coursesList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a single course
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.coursesRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['CoursesApi.coursesRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * CoursesApi - factory interface
 * @export
 */
export const CoursesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CoursesApiFp(configuration);
    return {
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File List
         * @param {CoursesApiCoursesContentfilesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesContentfilesList(requestParameters, options) {
            return localVarFp.coursesContentfilesList(requestParameters.learning_resource_id, requestParameters.content_feature_type, requestParameters.edx_module_id, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.resource_id, requestParameters.run_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File Retrieve
         * @param {CoursesApiCoursesContentfilesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesContentfilesRetrieve(requestParameters, options) {
            return localVarFp.coursesContentfilesRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a paginated list of courses
         * @summary List
         * @param {CoursesApiCoursesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesList(requestParameters = {}, options) {
            return localVarFp.coursesList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single course
         * @summary Retrieve
         * @param {CoursesApiCoursesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursesRetrieve(requestParameters, options) {
            return localVarFp.coursesRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CoursesApi - object-oriented interface
 * @export
 * @class CoursesApi
 * @extends {BaseAPI}
 */
export class CoursesApi extends BaseAPI {
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File List
     * @param {CoursesApiCoursesContentfilesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    coursesContentfilesList(requestParameters, options) {
        return CoursesApiFp(this.configuration).coursesContentfilesList(requestParameters.learning_resource_id, requestParameters.content_feature_type, requestParameters.edx_module_id, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.resource_id, requestParameters.run_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File Retrieve
     * @param {CoursesApiCoursesContentfilesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    coursesContentfilesRetrieve(requestParameters, options) {
        return CoursesApiFp(this.configuration).coursesContentfilesRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a paginated list of courses
     * @summary List
     * @param {CoursesApiCoursesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    coursesList(requestParameters = {}, options) {
        return CoursesApiFp(this.configuration).coursesList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single course
     * @summary Retrieve
     * @param {CoursesApiCoursesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoursesApi
     */
    coursesRetrieve(requestParameters, options) {
        return CoursesApiFp(this.configuration).coursesRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const CoursesContentfilesListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const CoursesContentfilesListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const CoursesListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const CoursesListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const CoursesListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const CoursesListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const CoursesListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const CoursesListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const CoursesListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const CoursesListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const CoursesListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
/**
 * DepartmentsApi - axios parameter creator
 * @export
 */
export const DepartmentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * MIT academic departments
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentsList: (limit_1, offset_1, ...args_1) => __awaiter(this, [limit_1, offset_1, ...args_1], void 0, function* (limit, offset, options = {}) {
            const localVarPath = `/api/v1/departments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * MIT academic departments
         * @summary Retrieve
         * @param {string} department_id A unique value identifying this learning resource department.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentsRetrieve: (department_id_1, ...args_2) => __awaiter(this, [department_id_1, ...args_2], void 0, function* (department_id, options = {}) {
            // verify required parameter 'department_id' is not null or undefined
            assertParamExists('departmentsRetrieve', 'department_id', department_id);
            const localVarPath = `/api/v1/departments/{department_id}/`
                .replace(`{${"department_id"}}`, encodeURIComponent(String(department_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DepartmentsApi - functional programming interface
 * @export
 */
export const DepartmentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DepartmentsApiAxiosParamCreator(configuration);
    return {
        /**
         * MIT academic departments
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentsList(limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.departmentsList(limit, offset, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['DepartmentsApi.departmentsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * MIT academic departments
         * @summary Retrieve
         * @param {string} department_id A unique value identifying this learning resource department.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentsRetrieve(department_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.departmentsRetrieve(department_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['DepartmentsApi.departmentsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * DepartmentsApi - factory interface
 * @export
 */
export const DepartmentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DepartmentsApiFp(configuration);
    return {
        /**
         * MIT academic departments
         * @summary List
         * @param {DepartmentsApiDepartmentsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentsList(requestParameters = {}, options) {
            return localVarFp.departmentsList(requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * MIT academic departments
         * @summary Retrieve
         * @param {DepartmentsApiDepartmentsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentsRetrieve(requestParameters, options) {
            return localVarFp.departmentsRetrieve(requestParameters.department_id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DepartmentsApi - object-oriented interface
 * @export
 * @class DepartmentsApi
 * @extends {BaseAPI}
 */
export class DepartmentsApi extends BaseAPI {
    /**
     * MIT academic departments
     * @summary List
     * @param {DepartmentsApiDepartmentsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    departmentsList(requestParameters = {}, options) {
        return DepartmentsApiFp(this.configuration).departmentsList(requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * MIT academic departments
     * @summary Retrieve
     * @param {DepartmentsApiDepartmentsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    departmentsRetrieve(requestParameters, options) {
        return DepartmentsApiFp(this.configuration).departmentsRetrieve(requestParameters.department_id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FeaturedApi - axios parameter creator
 * @export
 */
export const FeaturedApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a paginated list of featured resources
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<FeaturedListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<FeaturedListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<FeaturedListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<FeaturedListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<FeaturedListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<FeaturedListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<FeaturedListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<FeaturedListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {FeaturedListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuredList: (certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, offered_by_1, offset_1, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_1) => __awaiter(this, [certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, offered_by_1, offset_1, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_1], void 0, function* (certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            const localVarPath = `/api/v1/featured/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a single featured resource
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuredRetrieve: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('featuredRetrieve', 'id', id);
            const localVarPath = `/api/v1/featured/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FeaturedApi - functional programming interface
 * @export
 */
export const FeaturedApiFp = function (configuration) {
    const localVarAxiosParamCreator = FeaturedApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a paginated list of featured resources
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<FeaturedListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<FeaturedListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<FeaturedListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<FeaturedListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<FeaturedListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<FeaturedListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<FeaturedListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<FeaturedListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {FeaturedListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuredList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.featuredList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['FeaturedApi.featuredList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a single featured resource
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuredRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.featuredRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['FeaturedApi.featuredRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * FeaturedApi - factory interface
 * @export
 */
export const FeaturedApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FeaturedApiFp(configuration);
    return {
        /**
         * Get a paginated list of featured resources
         * @summary List
         * @param {FeaturedApiFeaturedListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuredList(requestParameters = {}, options) {
            return localVarFp.featuredList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single featured resource
         * @summary Retrieve
         * @param {FeaturedApiFeaturedRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuredRetrieve(requestParameters, options) {
            return localVarFp.featuredRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FeaturedApi - object-oriented interface
 * @export
 * @class FeaturedApi
 * @extends {BaseAPI}
 */
export class FeaturedApi extends BaseAPI {
    /**
     * Get a paginated list of featured resources
     * @summary List
     * @param {FeaturedApiFeaturedListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturedApi
     */
    featuredList(requestParameters = {}, options) {
        return FeaturedApiFp(this.configuration).featuredList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single featured resource
     * @summary Retrieve
     * @param {FeaturedApiFeaturedRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturedApi
     */
    featuredRetrieve(requestParameters, options) {
        return FeaturedApiFp(this.configuration).featuredRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const FeaturedListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const FeaturedListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const FeaturedListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const FeaturedListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const FeaturedListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const FeaturedListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const FeaturedListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const FeaturedListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const FeaturedListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
/**
 * LearningResourceDisplayInfoApi - axios parameter creator
 * @export
 */
export const LearningResourceDisplayInfoApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a paginated list of learning resource display info
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<LearningResourceDisplayInfoListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<LearningResourceDisplayInfoListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourceDisplayInfoListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<LearningResourceDisplayInfoListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<LearningResourceDisplayInfoListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<LearningResourceDisplayInfoListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<LearningResourceDisplayInfoListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourceDisplayInfoListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {LearningResourceDisplayInfoListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourceDisplayInfoList: (certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, offered_by_1, offset_1, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_1) => __awaiter(this, [certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, offered_by_1, offset_1, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_1], void 0, function* (certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            const localVarPath = `/api/v1/learning_resource_display_info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve display info for a learning resource.
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourceDisplayInfoRetrieve: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningResourceDisplayInfoRetrieve', 'id', id);
            const localVarPath = `/api/v1/learning_resource_display_info/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LearningResourceDisplayInfoApi - functional programming interface
 * @export
 */
export const LearningResourceDisplayInfoApiFp = function (configuration) {
    const localVarAxiosParamCreator = LearningResourceDisplayInfoApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a paginated list of learning resource display info
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<LearningResourceDisplayInfoListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<LearningResourceDisplayInfoListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourceDisplayInfoListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<LearningResourceDisplayInfoListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<LearningResourceDisplayInfoListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<LearningResourceDisplayInfoListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<LearningResourceDisplayInfoListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourceDisplayInfoListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {LearningResourceDisplayInfoListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourceDisplayInfoList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourceDisplayInfoList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourceDisplayInfoApi.learningResourceDisplayInfoList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve display info for a learning resource.
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourceDisplayInfoRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourceDisplayInfoRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourceDisplayInfoApi.learningResourceDisplayInfoRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * LearningResourceDisplayInfoApi - factory interface
 * @export
 */
export const LearningResourceDisplayInfoApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LearningResourceDisplayInfoApiFp(configuration);
    return {
        /**
         * Get a paginated list of learning resource display info
         * @summary List
         * @param {LearningResourceDisplayInfoApiLearningResourceDisplayInfoListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourceDisplayInfoList(requestParameters = {}, options) {
            return localVarFp.learningResourceDisplayInfoList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve display info for a learning resource.
         * @summary Retrieve
         * @param {LearningResourceDisplayInfoApiLearningResourceDisplayInfoRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourceDisplayInfoRetrieve(requestParameters, options) {
            return localVarFp.learningResourceDisplayInfoRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LearningResourceDisplayInfoApi - object-oriented interface
 * @export
 * @class LearningResourceDisplayInfoApi
 * @extends {BaseAPI}
 */
export class LearningResourceDisplayInfoApi extends BaseAPI {
    /**
     * Get a paginated list of learning resource display info
     * @summary List
     * @param {LearningResourceDisplayInfoApiLearningResourceDisplayInfoListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourceDisplayInfoApi
     */
    learningResourceDisplayInfoList(requestParameters = {}, options) {
        return LearningResourceDisplayInfoApiFp(this.configuration).learningResourceDisplayInfoList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve display info for a learning resource.
     * @summary Retrieve
     * @param {LearningResourceDisplayInfoApiLearningResourceDisplayInfoRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourceDisplayInfoApi
     */
    learningResourceDisplayInfoRetrieve(requestParameters, options) {
        return LearningResourceDisplayInfoApiFp(this.configuration).learningResourceDisplayInfoRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const LearningResourceDisplayInfoListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const LearningResourceDisplayInfoListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const LearningResourceDisplayInfoListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const LearningResourceDisplayInfoListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const LearningResourceDisplayInfoListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const LearningResourceDisplayInfoListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const LearningResourceDisplayInfoListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const LearningResourceDisplayInfoListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const LearningResourceDisplayInfoListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
/**
 * LearningResourcesApi - axios parameter creator
 * @export
 */
export const LearningResourcesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {Array<string>} [content_feature_type] Multiple values may be separated by commas.
         * @param {Array<string>} [edx_module_id] Multiple values may be separated by commas.
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<LearningResourcesContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<LearningResourcesContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {Array<number>} [resource_id] Multiple values may be separated by commas.
         * @param {Array<number>} [run_id] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesContentfilesList: (learning_resource_id_1, content_feature_type_1, edx_module_id_1, limit_1, offered_by_1, offset_1, platform_1, resource_id_1, run_id_1, ...args_1) => __awaiter(this, [learning_resource_id_1, content_feature_type_1, edx_module_id_1, limit_1, offered_by_1, offset_1, platform_1, resource_id_1, run_id_1, ...args_1], void 0, function* (learning_resource_id, content_feature_type, edx_module_id, limit, offered_by, offset, platform, resource_id, run_id, options = {}) {
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('learningResourcesContentfilesList', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/learning_resources/{learning_resource_id}/contentfiles/`
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (content_feature_type) {
                localVarQueryParameter['content_feature_type'] = content_feature_type.join(COLLECTION_FORMATS.csv);
            }
            if (edx_module_id) {
                localVarQueryParameter['edx_module_id'] = edx_module_id.join(COLLECTION_FORMATS.csv);
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (resource_id) {
                localVarQueryParameter['resource_id'] = resource_id.join(COLLECTION_FORMATS.csv);
            }
            if (run_id) {
                localVarQueryParameter['run_id'] = run_id.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File Retrieve
         * @param {number} id A unique integer value identifying this contentfile.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesContentfilesRetrieve: (id_1, learning_resource_id_2, ...args_2) => __awaiter(this, [id_1, learning_resource_id_2, ...args_2], void 0, function* (id, learning_resource_id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningResourcesContentfilesRetrieve', 'id', id);
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('learningResourcesContentfilesRetrieve', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/learning_resources/{learning_resource_id}/contentfiles/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a list of related learning resources for a learning resource.
         * @summary Nested Learning Resource List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [sortby] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesItemsList: (learning_resource_id_3, limit_2, offset_2, sortby_1, ...args_3) => __awaiter(this, [learning_resource_id_3, limit_2, offset_2, sortby_1, ...args_3], void 0, function* (learning_resource_id, limit, offset, sortby, options = {}) {
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('learningResourcesItemsList', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/learning_resources/{learning_resource_id}/items/`
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesItemsRetrieve: (id_2, learning_resource_id_4, ...args_4) => __awaiter(this, [id_2, learning_resource_id_4, ...args_4], void 0, function* (id, learning_resource_id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningResourcesItemsRetrieve', 'id', id);
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('learningResourcesItemsRetrieve', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/learning_resources/{learning_resource_id}/items/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set Learning Path Relationships on a given Learning Resource.
         * @summary Set Learning Path Relationships
         * @param {number} id id of the learning resource
         * @param {Array<number>} [learning_path_id] id of the parent learning path
         * @param {PatchedLearningResourceRelationshipRequest} [PatchedLearningResourceRelationshipRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesLearningPathsPartialUpdate: (id_3, learning_path_id_1, PatchedLearningResourceRelationshipRequest_1, ...args_5) => __awaiter(this, [id_3, learning_path_id_1, PatchedLearningResourceRelationshipRequest_1, ...args_5], void 0, function* (id, learning_path_id, PatchedLearningResourceRelationshipRequest, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningResourcesLearningPathsPartialUpdate', 'id', id);
            const localVarPath = `/api/v1/learning_resources/{id}/learning_paths/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (learning_path_id) {
                localVarQueryParameter['learning_path_id'] = learning_path_id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PatchedLearningResourceRelationshipRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a paginated list of learning resources.
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<LearningResourcesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<LearningResourcesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<LearningResourcesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<LearningResourcesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<LearningResourcesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<LearningResourcesListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {LearningResourcesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesList: (certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_3, offered_by_2, offset_3, platform_2, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_2, topic_1, ...args_6) => __awaiter(this, [certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_3, offered_by_2, offset_3, platform_2, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_2, topic_1, ...args_6], void 0, function* (certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            const localVarPath = `/api/v1/learning_resources/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a single learning resource.
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesRetrieve: (id_4, ...args_7) => __awaiter(this, [id_4, ...args_7], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningResourcesRetrieve', 'id', id);
            const localVarPath = `/api/v1/learning_resources/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch similar learning resources  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
         * @summary Get similar resources
         * @param {number} id
         * @param {boolean} [certification]
         * @param {Array<LearningResourcesSimilarListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<LearningResourcesSimilarListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesSimilarListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<LearningResourcesSimilarListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit]
         * @param {Array<LearningResourcesSimilarListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {Array<LearningResourcesSimilarListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<LearningResourcesSimilarListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesSimilarListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {LearningResourcesSimilarListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesSimilarList: (id_5, certification_2, certification_type_2, course_feature_2, delivery_2, department_2, free_2, level_2, limit_4, offered_by_3, platform_3, professional_2, readable_id_2, resource_category_2, resource_type_2, sortby_3, topic_2, ...args_8) => __awaiter(this, [id_5, certification_2, certification_type_2, course_feature_2, delivery_2, department_2, free_2, level_2, limit_4, offered_by_3, platform_3, professional_2, readable_id_2, resource_category_2, resource_type_2, sortby_3, topic_2, ...args_8], void 0, function* (id, certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningResourcesSimilarList', 'id', id);
            const localVarPath = `/api/v1/learning_resources/{id}/similar/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Set User List Relationships on a given Learning Resource.
         * @summary Set User List Relationships
         * @param {number} id id of the learning resource
         * @param {Array<number>} [userlist_id] id of the parent user list
         * @param {PatchedUserListRelationshipRequest} [PatchedUserListRelationshipRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserlistsPartialUpdate: (id_6, userlist_id_1, PatchedUserListRelationshipRequest_1, ...args_9) => __awaiter(this, [id_6, userlist_id_1, PatchedUserListRelationshipRequest_1, ...args_9], void 0, function* (id, userlist_id, PatchedUserListRelationshipRequest, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningResourcesUserlistsPartialUpdate', 'id', id);
            const localVarPath = `/api/v1/learning_resources/{id}/userlists/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (userlist_id) {
                localVarQueryParameter['userlist_id'] = userlist_id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PatchedUserListRelationshipRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch similar learning resources  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
         * @summary Get similar resources using vector embeddings
         * @param {number} id
         * @param {boolean} [certification]
         * @param {Array<LearningResourcesVectorSimilarListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<LearningResourcesVectorSimilarListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesVectorSimilarListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<LearningResourcesVectorSimilarListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit]
         * @param {Array<LearningResourcesVectorSimilarListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {Array<LearningResourcesVectorSimilarListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<LearningResourcesVectorSimilarListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesVectorSimilarListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {LearningResourcesVectorSimilarListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesVectorSimilarList: (id_7, certification_3, certification_type_3, course_feature_3, delivery_3, department_3, free_3, level_3, limit_5, offered_by_4, platform_4, professional_3, readable_id_3, resource_category_3, resource_type_3, sortby_4, topic_3, ...args_10) => __awaiter(this, [id_7, certification_3, certification_type_3, course_feature_3, delivery_3, department_3, free_3, level_3, limit_5, offered_by_4, platform_4, professional_3, readable_id_3, resource_category_3, resource_type_3, sortby_4, topic_3, ...args_10], void 0, function* (id, certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningResourcesVectorSimilarList', 'id', id);
            const localVarPath = `/api/v1/learning_resources/{id}/vector_similar/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LearningResourcesApi - functional programming interface
 * @export
 */
export const LearningResourcesApiFp = function (configuration) {
    const localVarAxiosParamCreator = LearningResourcesApiAxiosParamCreator(configuration);
    return {
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {Array<string>} [content_feature_type] Multiple values may be separated by commas.
         * @param {Array<string>} [edx_module_id] Multiple values may be separated by commas.
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<LearningResourcesContentfilesListOfferedByEnum>} [offered_by] The organization that offers a learning resource the content file belongs to  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<LearningResourcesContentfilesListPlatformEnum>} [platform] The platform on which learning resources the content file belongs to is offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {Array<number>} [resource_id] Multiple values may be separated by commas.
         * @param {Array<number>} [run_id] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesContentfilesList(learning_resource_id, content_feature_type, edx_module_id, limit, offered_by, offset, platform, resource_id, run_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesContentfilesList(learning_resource_id, content_feature_type, edx_module_id, limit, offered_by, offset, platform, resource_id, run_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesApi.learningResourcesContentfilesList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File Retrieve
         * @param {number} id A unique integer value identifying this contentfile.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesContentfilesRetrieve(id, learning_resource_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesContentfilesRetrieve(id, learning_resource_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesApi.learningResourcesContentfilesRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a list of related learning resources for a learning resource.
         * @summary Nested Learning Resource List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [sortby] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesItemsList(learning_resource_id, limit, offset, sortby, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesItemsList(learning_resource_id, limit, offset, sortby, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesApi.learningResourcesItemsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesItemsRetrieve(id, learning_resource_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesItemsRetrieve(id, learning_resource_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesApi.learningResourcesItemsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Set Learning Path Relationships on a given Learning Resource.
         * @summary Set Learning Path Relationships
         * @param {number} id id of the learning resource
         * @param {Array<number>} [learning_path_id] id of the parent learning path
         * @param {PatchedLearningResourceRelationshipRequest} [PatchedLearningResourceRelationshipRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesLearningPathsPartialUpdate(id, learning_path_id, PatchedLearningResourceRelationshipRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesLearningPathsPartialUpdate(id, learning_path_id, PatchedLearningResourceRelationshipRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesApi.learningResourcesLearningPathsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a paginated list of learning resources.
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<LearningResourcesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<LearningResourcesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<LearningResourcesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<LearningResourcesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<LearningResourcesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<LearningResourcesListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {LearningResourcesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesApi.learningResourcesList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a single learning resource.
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesApi.learningResourcesRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Fetch similar learning resources  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
         * @summary Get similar resources
         * @param {number} id
         * @param {boolean} [certification]
         * @param {Array<LearningResourcesSimilarListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<LearningResourcesSimilarListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesSimilarListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<LearningResourcesSimilarListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit]
         * @param {Array<LearningResourcesSimilarListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {Array<LearningResourcesSimilarListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<LearningResourcesSimilarListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesSimilarListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {LearningResourcesSimilarListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesSimilarList(id, certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesSimilarList(id, certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesApi.learningResourcesSimilarList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Set User List Relationships on a given Learning Resource.
         * @summary Set User List Relationships
         * @param {number} id id of the learning resource
         * @param {Array<number>} [userlist_id] id of the parent user list
         * @param {PatchedUserListRelationshipRequest} [PatchedUserListRelationshipRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserlistsPartialUpdate(id, userlist_id, PatchedUserListRelationshipRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesUserlistsPartialUpdate(id, userlist_id, PatchedUserListRelationshipRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesApi.learningResourcesUserlistsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Fetch similar learning resources  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
         * @summary Get similar resources using vector embeddings
         * @param {number} id
         * @param {boolean} [certification]
         * @param {Array<LearningResourcesVectorSimilarListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<LearningResourcesVectorSimilarListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesVectorSimilarListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<LearningResourcesVectorSimilarListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit]
         * @param {Array<LearningResourcesVectorSimilarListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {Array<LearningResourcesVectorSimilarListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<LearningResourcesVectorSimilarListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesVectorSimilarListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {LearningResourcesVectorSimilarListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesVectorSimilarList(id, certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesVectorSimilarList(id, certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesApi.learningResourcesVectorSimilarList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * LearningResourcesApi - factory interface
 * @export
 */
export const LearningResourcesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LearningResourcesApiFp(configuration);
    return {
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File List
         * @param {LearningResourcesApiLearningResourcesContentfilesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesContentfilesList(requestParameters, options) {
            return localVarFp.learningResourcesContentfilesList(requestParameters.learning_resource_id, requestParameters.content_feature_type, requestParameters.edx_module_id, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.resource_id, requestParameters.run_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Show content files for a learning resource
         * @summary Learning Resource Content File Retrieve
         * @param {LearningResourcesApiLearningResourcesContentfilesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesContentfilesRetrieve(requestParameters, options) {
            return localVarFp.learningResourcesContentfilesRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of related learning resources for a learning resource.
         * @summary Nested Learning Resource List
         * @param {LearningResourcesApiLearningResourcesItemsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesItemsList(requestParameters, options) {
            return localVarFp.learningResourcesItemsList(requestParameters.learning_resource_id, requestParameters.limit, requestParameters.offset, requestParameters.sortby, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {LearningResourcesApiLearningResourcesItemsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesItemsRetrieve(requestParameters, options) {
            return localVarFp.learningResourcesItemsRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Set Learning Path Relationships on a given Learning Resource.
         * @summary Set Learning Path Relationships
         * @param {LearningResourcesApiLearningResourcesLearningPathsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesLearningPathsPartialUpdate(requestParameters, options) {
            return localVarFp.learningResourcesLearningPathsPartialUpdate(requestParameters.id, requestParameters.learning_path_id, requestParameters.PatchedLearningResourceRelationshipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a paginated list of learning resources.
         * @summary List
         * @param {LearningResourcesApiLearningResourcesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesList(requestParameters = {}, options) {
            return localVarFp.learningResourcesList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single learning resource.
         * @summary Retrieve
         * @param {LearningResourcesApiLearningResourcesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesRetrieve(requestParameters, options) {
            return localVarFp.learningResourcesRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch similar learning resources  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
         * @summary Get similar resources
         * @param {LearningResourcesApiLearningResourcesSimilarListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesSimilarList(requestParameters, options) {
            return localVarFp.learningResourcesSimilarList(requestParameters.id, requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Set User List Relationships on a given Learning Resource.
         * @summary Set User List Relationships
         * @param {LearningResourcesApiLearningResourcesUserlistsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserlistsPartialUpdate(requestParameters, options) {
            return localVarFp.learningResourcesUserlistsPartialUpdate(requestParameters.id, requestParameters.userlist_id, requestParameters.PatchedUserListRelationshipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch similar learning resources  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
         * @summary Get similar resources using vector embeddings
         * @param {LearningResourcesApiLearningResourcesVectorSimilarListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesVectorSimilarList(requestParameters, options) {
            return localVarFp.learningResourcesVectorSimilarList(requestParameters.id, requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LearningResourcesApi - object-oriented interface
 * @export
 * @class LearningResourcesApi
 * @extends {BaseAPI}
 */
export class LearningResourcesApi extends BaseAPI {
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File List
     * @param {LearningResourcesApiLearningResourcesContentfilesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesApi
     */
    learningResourcesContentfilesList(requestParameters, options) {
        return LearningResourcesApiFp(this.configuration).learningResourcesContentfilesList(requestParameters.learning_resource_id, requestParameters.content_feature_type, requestParameters.edx_module_id, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.resource_id, requestParameters.run_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Show content files for a learning resource
     * @summary Learning Resource Content File Retrieve
     * @param {LearningResourcesApiLearningResourcesContentfilesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesApi
     */
    learningResourcesContentfilesRetrieve(requestParameters, options) {
        return LearningResourcesApiFp(this.configuration).learningResourcesContentfilesRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {LearningResourcesApiLearningResourcesItemsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesApi
     */
    learningResourcesItemsList(requestParameters, options) {
        return LearningResourcesApiFp(this.configuration).learningResourcesItemsList(requestParameters.learning_resource_id, requestParameters.limit, requestParameters.offset, requestParameters.sortby, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {LearningResourcesApiLearningResourcesItemsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesApi
     */
    learningResourcesItemsRetrieve(requestParameters, options) {
        return LearningResourcesApiFp(this.configuration).learningResourcesItemsRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set Learning Path Relationships on a given Learning Resource.
     * @summary Set Learning Path Relationships
     * @param {LearningResourcesApiLearningResourcesLearningPathsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesApi
     */
    learningResourcesLearningPathsPartialUpdate(requestParameters, options) {
        return LearningResourcesApiFp(this.configuration).learningResourcesLearningPathsPartialUpdate(requestParameters.id, requestParameters.learning_path_id, requestParameters.PatchedLearningResourceRelationshipRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a paginated list of learning resources.
     * @summary List
     * @param {LearningResourcesApiLearningResourcesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesApi
     */
    learningResourcesList(requestParameters = {}, options) {
        return LearningResourcesApiFp(this.configuration).learningResourcesList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single learning resource.
     * @summary Retrieve
     * @param {LearningResourcesApiLearningResourcesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesApi
     */
    learningResourcesRetrieve(requestParameters, options) {
        return LearningResourcesApiFp(this.configuration).learningResourcesRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch similar learning resources  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
     * @summary Get similar resources
     * @param {LearningResourcesApiLearningResourcesSimilarListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesApi
     */
    learningResourcesSimilarList(requestParameters, options) {
        return LearningResourcesApiFp(this.configuration).learningResourcesSimilarList(requestParameters.id, requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Set User List Relationships on a given Learning Resource.
     * @summary Set User List Relationships
     * @param {LearningResourcesApiLearningResourcesUserlistsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesApi
     */
    learningResourcesUserlistsPartialUpdate(requestParameters, options) {
        return LearningResourcesApiFp(this.configuration).learningResourcesUserlistsPartialUpdate(requestParameters.id, requestParameters.userlist_id, requestParameters.PatchedUserListRelationshipRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch similar learning resources  Args: id (integer): The id of the learning resource  Returns: QuerySet of similar LearningResource for the resource matching the id parameter
     * @summary Get similar resources using vector embeddings
     * @param {LearningResourcesApiLearningResourcesVectorSimilarListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesApi
     */
    learningResourcesVectorSimilarList(requestParameters, options) {
        return LearningResourcesApiFp(this.configuration).learningResourcesVectorSimilarList(requestParameters.id, requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const LearningResourcesContentfilesListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const LearningResourcesContentfilesListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const LearningResourcesListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const LearningResourcesListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const LearningResourcesListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const LearningResourcesListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const LearningResourcesListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const LearningResourcesListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const LearningResourcesListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const LearningResourcesListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const LearningResourcesListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
/**
 * @export
 */
export const LearningResourcesSimilarListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const LearningResourcesSimilarListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const LearningResourcesSimilarListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const LearningResourcesSimilarListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const LearningResourcesSimilarListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const LearningResourcesSimilarListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const LearningResourcesSimilarListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const LearningResourcesSimilarListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const LearningResourcesSimilarListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
/**
 * @export
 */
export const LearningResourcesVectorSimilarListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const LearningResourcesVectorSimilarListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const LearningResourcesVectorSimilarListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const LearningResourcesVectorSimilarListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const LearningResourcesVectorSimilarListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const LearningResourcesVectorSimilarListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const LearningResourcesVectorSimilarListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const LearningResourcesVectorSimilarListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const LearningResourcesVectorSimilarListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
/**
 * LearningResourcesSearchApi - axios parameter creator
 * @export
 */
export const LearningResourcesSearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Search for learning resources
         * @summary Search
         * @param {Array<LearningResourcesSearchRetrieveAggregationsEnum>} [aggregations] Show resource counts by category
         * @param {boolean | null} [certification] True if the learning resource offers a certificate
         * @param {Array<LearningResourcesSearchRetrieveCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
         * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
         * @param {Array<LearningResourcesSearchRetrieveDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesSearchRetrieveDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
         * @param {boolean | null} [free]
         * @param {Array<number>} [id] The id value for the learning resource
         * @param {Array<LearningResourcesSearchRetrieveLevelEnum>} [level]
         * @param {number} [limit] Number of results to return per page
         * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
         * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<LearningResourcesSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<LearningResourcesSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean | null} [professional]
         * @param {string} [q] The search text
         * @param {Array<LearningResourcesSearchRetrieveResourceCategoryEnum>} [resource_category] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesSearchRetrieveResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist
         * @param {LearningResourcesSearchRetrieveSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase  * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase
         * @param {number | null} [slop] Allowed distance for phrase search
         * @param {LearningResourcesSearchRetrieveSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesSearchRetrieve: (aggregations_1, certification_1, certification_type_1, content_file_score_weight_1, course_feature_1, delivery_1, department_1, dev_mode_1, free_1, id_1, level_1, limit_1, max_incompleteness_penalty_1, min_score_1, ocw_topic_1, offered_by_1, offset_1, platform_1, professional_1, q_1, resource_category_1, resource_type_1, search_mode_1, slop_1, sortby_1, topic_1, yearly_decay_percent_1, ...args_1) => __awaiter(this, [aggregations_1, certification_1, certification_type_1, content_file_score_weight_1, course_feature_1, delivery_1, department_1, dev_mode_1, free_1, id_1, level_1, limit_1, max_incompleteness_penalty_1, min_score_1, ocw_topic_1, offered_by_1, offset_1, platform_1, professional_1, q_1, resource_category_1, resource_type_1, search_mode_1, slop_1, sortby_1, topic_1, yearly_decay_percent_1, ...args_1], void 0, function* (aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, topic, yearly_decay_percent, options = {}) {
            const localVarPath = `/api/v1/learning_resources_search/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aggregations) {
                localVarQueryParameter['aggregations'] = aggregations;
            }
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (content_file_score_weight !== undefined) {
                localVarQueryParameter['content_file_score_weight'] = content_file_score_weight;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature;
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (dev_mode !== undefined) {
                localVarQueryParameter['dev_mode'] = dev_mode;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (max_incompleteness_penalty !== undefined) {
                localVarQueryParameter['max_incompleteness_penalty'] = max_incompleteness_penalty;
            }
            if (min_score !== undefined) {
                localVarQueryParameter['min_score'] = min_score;
            }
            if (ocw_topic) {
                localVarQueryParameter['ocw_topic'] = ocw_topic;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (search_mode !== undefined) {
                localVarQueryParameter['search_mode'] = search_mode;
            }
            if (slop !== undefined) {
                localVarQueryParameter['slop'] = slop;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic;
            }
            if (yearly_decay_percent !== undefined) {
                localVarQueryParameter['yearly_decay_percent'] = yearly_decay_percent;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LearningResourcesSearchApi - functional programming interface
 * @export
 */
export const LearningResourcesSearchApiFp = function (configuration) {
    const localVarAxiosParamCreator = LearningResourcesSearchApiAxiosParamCreator(configuration);
    return {
        /**
         * Search for learning resources
         * @summary Search
         * @param {Array<LearningResourcesSearchRetrieveAggregationsEnum>} [aggregations] Show resource counts by category
         * @param {boolean | null} [certification] True if the learning resource offers a certificate
         * @param {Array<LearningResourcesSearchRetrieveCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
         * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
         * @param {Array<LearningResourcesSearchRetrieveDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesSearchRetrieveDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
         * @param {boolean | null} [free]
         * @param {Array<number>} [id] The id value for the learning resource
         * @param {Array<LearningResourcesSearchRetrieveLevelEnum>} [level]
         * @param {number} [limit] Number of results to return per page
         * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
         * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<LearningResourcesSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<LearningResourcesSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean | null} [professional]
         * @param {string} [q] The search text
         * @param {Array<LearningResourcesSearchRetrieveResourceCategoryEnum>} [resource_category] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesSearchRetrieveResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist
         * @param {LearningResourcesSearchRetrieveSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase  * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase
         * @param {number | null} [slop] Allowed distance for phrase search
         * @param {LearningResourcesSearchRetrieveSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesSearchRetrieve(aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, topic, yearly_decay_percent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesSearchRetrieve(aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, topic, yearly_decay_percent, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesSearchApi.learningResourcesSearchRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * LearningResourcesSearchApi - factory interface
 * @export
 */
export const LearningResourcesSearchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LearningResourcesSearchApiFp(configuration);
    return {
        /**
         * Search for learning resources
         * @summary Search
         * @param {LearningResourcesSearchApiLearningResourcesSearchRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesSearchRetrieve(requestParameters = {}, options) {
            return localVarFp.learningResourcesSearchRetrieve(requestParameters.aggregations, requestParameters.certification, requestParameters.certification_type, requestParameters.content_file_score_weight, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.dev_mode, requestParameters.free, requestParameters.id, requestParameters.level, requestParameters.limit, requestParameters.max_incompleteness_penalty, requestParameters.min_score, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.q, requestParameters.resource_category, requestParameters.resource_type, requestParameters.search_mode, requestParameters.slop, requestParameters.sortby, requestParameters.topic, requestParameters.yearly_decay_percent, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LearningResourcesSearchApi - object-oriented interface
 * @export
 * @class LearningResourcesSearchApi
 * @extends {BaseAPI}
 */
export class LearningResourcesSearchApi extends BaseAPI {
    /**
     * Search for learning resources
     * @summary Search
     * @param {LearningResourcesSearchApiLearningResourcesSearchRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesSearchApi
     */
    learningResourcesSearchRetrieve(requestParameters = {}, options) {
        return LearningResourcesSearchApiFp(this.configuration).learningResourcesSearchRetrieve(requestParameters.aggregations, requestParameters.certification, requestParameters.certification_type, requestParameters.content_file_score_weight, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.dev_mode, requestParameters.free, requestParameters.id, requestParameters.level, requestParameters.limit, requestParameters.max_incompleteness_penalty, requestParameters.min_score, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.q, requestParameters.resource_category, requestParameters.resource_type, requestParameters.search_mode, requestParameters.slop, requestParameters.sortby, requestParameters.topic, requestParameters.yearly_decay_percent, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const LearningResourcesSearchRetrieveAggregationsEnum = {
    ResourceType: 'resource_type',
    Certification: 'certification',
    CertificationType: 'certification_type',
    OfferedBy: 'offered_by',
    Platform: 'platform',
    Topic: 'topic',
    Department: 'department',
    Level: 'level',
    CourseFeature: 'course_feature',
    Professional: 'professional',
    Free: 'free',
    Delivery: 'delivery',
    ResourceCategory: 'resource_category'
};
/**
 * @export
 */
export const LearningResourcesSearchRetrieveCertificationTypeEnum = {
    Micromasters: 'micromasters',
    Professional: 'professional',
    Completion: 'completion',
    None: 'none'
};
/**
 * @export
 */
export const LearningResourcesSearchRetrieveDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const LearningResourcesSearchRetrieveDepartmentEnum = {
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const LearningResourcesSearchRetrieveLevelEnum = {
    Undergraduate: 'undergraduate',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Noncredit: 'noncredit',
    Advanced: 'advanced',
    Intermediate: 'intermediate',
    Introductory: 'introductory'
};
/**
 * @export
 */
export const LearningResourcesSearchRetrieveOfferedByEnum = {
    Mitx: 'mitx',
    Ocw: 'ocw',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Mitpe: 'mitpe',
    See: 'see'
};
/**
 * @export
 */
export const LearningResourcesSearchRetrievePlatformEnum = {
    Edx: 'edx',
    Ocw: 'ocw',
    Oll: 'oll',
    Mitxonline: 'mitxonline',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Csail: 'csail',
    Mitpe: 'mitpe',
    See: 'see',
    Scc: 'scc',
    Ctl: 'ctl',
    Whu: 'whu',
    Susskind: 'susskind',
    Globalalumni: 'globalalumni',
    Simplilearn: 'simplilearn',
    Emeritus: 'emeritus',
    Podcast: 'podcast',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const LearningResourcesSearchRetrieveResourceCategoryEnum = {
    Course: 'course',
    Program: 'program',
    LearningMaterial: 'learning_material'
};
/**
 * @export
 */
export const LearningResourcesSearchRetrieveResourceTypeEnum = {
    Course: 'course',
    Program: 'program',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const LearningResourcesSearchRetrieveSearchModeEnum = {
    BestFields: 'best_fields',
    MostFields: 'most_fields',
    Phrase: 'phrase'
};
/**
 * @export
 */
export const LearningResourcesSearchRetrieveSortbyEnum = {
    Featured: 'featured',
    Id: 'id',
    Id2: '-id',
    ReadableId: 'readable_id',
    ReadableId2: '-readable_id',
    LastModified: 'last_modified',
    LastModified2: '-last_modified',
    New: 'new',
    StartDate: 'start_date',
    StartDate2: '-start_date',
    Mitcoursenumber: 'mitcoursenumber',
    Mitcoursenumber2: '-mitcoursenumber',
    Views: 'views',
    Views2: '-views',
    Upcoming: 'upcoming'
};
/**
 * LearningResourcesUserSubscriptionApi - axios parameter creator
 * @export
 */
export const LearningResourcesUserSubscriptionApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * View for listing percolate query subscriptions for a user
         * @summary Check if a user is subscribed to a specific query
         * @param {Array<LearningResourcesUserSubscriptionCheckListAggregationsEnum>} [aggregations] Show resource counts by category
         * @param {boolean | null} [certification] True if the learning resource offers a certificate
         * @param {Array<LearningResourcesUserSubscriptionCheckListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
         * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
         * @param {Array<LearningResourcesUserSubscriptionCheckListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesUserSubscriptionCheckListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
         * @param {boolean | null} [free]
         * @param {Array<number>} [id] The id value for the learning resource
         * @param {Array<LearningResourcesUserSubscriptionCheckListLevelEnum>} [level]
         * @param {number} [limit] Number of results to return per page
         * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
         * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<LearningResourcesUserSubscriptionCheckListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<LearningResourcesUserSubscriptionCheckListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean | null} [professional]
         * @param {string} [q] The search text
         * @param {Array<LearningResourcesUserSubscriptionCheckListResourceCategoryEnum>} [resource_category] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesUserSubscriptionCheckListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist
         * @param {LearningResourcesUserSubscriptionCheckListSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase  * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase
         * @param {number | null} [slop] Allowed distance for phrase search
         * @param {LearningResourcesUserSubscriptionCheckListSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {LearningResourcesUserSubscriptionCheckListSourceTypeEnum} [source_type] The subscription type  * &#x60;search_subscription_type&#x60; - search_subscription_type * &#x60;channel_subscription_type&#x60; - channel_subscription_type
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionCheckList: (aggregations_1, certification_1, certification_type_1, content_file_score_weight_1, course_feature_1, delivery_1, department_1, dev_mode_1, free_1, id_1, level_1, limit_1, max_incompleteness_penalty_1, min_score_1, ocw_topic_1, offered_by_1, offset_1, platform_1, professional_1, q_1, resource_category_1, resource_type_1, search_mode_1, slop_1, sortby_1, source_type_1, topic_1, yearly_decay_percent_1, ...args_1) => __awaiter(this, [aggregations_1, certification_1, certification_type_1, content_file_score_weight_1, course_feature_1, delivery_1, department_1, dev_mode_1, free_1, id_1, level_1, limit_1, max_incompleteness_penalty_1, min_score_1, ocw_topic_1, offered_by_1, offset_1, platform_1, professional_1, q_1, resource_category_1, resource_type_1, search_mode_1, slop_1, sortby_1, source_type_1, topic_1, yearly_decay_percent_1, ...args_1], void 0, function* (aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, source_type, topic, yearly_decay_percent, options = {}) {
            const localVarPath = `/api/v1/learning_resources_user_subscription/check/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aggregations) {
                localVarQueryParameter['aggregations'] = aggregations;
            }
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (content_file_score_weight !== undefined) {
                localVarQueryParameter['content_file_score_weight'] = content_file_score_weight;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature;
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (dev_mode !== undefined) {
                localVarQueryParameter['dev_mode'] = dev_mode;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (max_incompleteness_penalty !== undefined) {
                localVarQueryParameter['max_incompleteness_penalty'] = max_incompleteness_penalty;
            }
            if (min_score !== undefined) {
                localVarQueryParameter['min_score'] = min_score;
            }
            if (ocw_topic) {
                localVarQueryParameter['ocw_topic'] = ocw_topic;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (search_mode !== undefined) {
                localVarQueryParameter['search_mode'] = search_mode;
            }
            if (slop !== undefined) {
                localVarQueryParameter['slop'] = slop;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (source_type !== undefined) {
                localVarQueryParameter['source_type'] = source_type;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic;
            }
            if (yearly_decay_percent !== undefined) {
                localVarQueryParameter['yearly_decay_percent'] = yearly_decay_percent;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for listing percolate query subscriptions for a user
         * @summary List subscribed queries
         * @param {Array<LearningResourcesUserSubscriptionListAggregationsEnum>} [aggregations] Show resource counts by category
         * @param {boolean | null} [certification] True if the learning resource offers a certificate
         * @param {Array<LearningResourcesUserSubscriptionListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
         * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
         * @param {Array<LearningResourcesUserSubscriptionListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesUserSubscriptionListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
         * @param {boolean | null} [free]
         * @param {Array<number>} [id] The id value for the learning resource
         * @param {Array<LearningResourcesUserSubscriptionListLevelEnum>} [level]
         * @param {number} [limit] Number of results to return per page
         * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
         * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<LearningResourcesUserSubscriptionListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<LearningResourcesUserSubscriptionListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean | null} [professional]
         * @param {string} [q] The search text
         * @param {Array<LearningResourcesUserSubscriptionListResourceCategoryEnum>} [resource_category] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesUserSubscriptionListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist
         * @param {LearningResourcesUserSubscriptionListSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase  * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase
         * @param {number | null} [slop] Allowed distance for phrase search
         * @param {LearningResourcesUserSubscriptionListSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionList: (aggregations_2, certification_2, certification_type_2, content_file_score_weight_2, course_feature_2, delivery_2, department_2, dev_mode_2, free_2, id_2, level_2, limit_2, max_incompleteness_penalty_2, min_score_2, ocw_topic_2, offered_by_2, offset_2, platform_2, professional_2, q_2, resource_category_2, resource_type_2, search_mode_2, slop_2, sortby_2, topic_2, yearly_decay_percent_2, ...args_2) => __awaiter(this, [aggregations_2, certification_2, certification_type_2, content_file_score_weight_2, course_feature_2, delivery_2, department_2, dev_mode_2, free_2, id_2, level_2, limit_2, max_incompleteness_penalty_2, min_score_2, ocw_topic_2, offered_by_2, offset_2, platform_2, professional_2, q_2, resource_category_2, resource_type_2, search_mode_2, slop_2, sortby_2, topic_2, yearly_decay_percent_2, ...args_2], void 0, function* (aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, topic, yearly_decay_percent, options = {}) {
            const localVarPath = `/api/v1/learning_resources_user_subscription/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aggregations) {
                localVarQueryParameter['aggregations'] = aggregations;
            }
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (content_file_score_weight !== undefined) {
                localVarQueryParameter['content_file_score_weight'] = content_file_score_weight;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature;
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (dev_mode !== undefined) {
                localVarQueryParameter['dev_mode'] = dev_mode;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (max_incompleteness_penalty !== undefined) {
                localVarQueryParameter['max_incompleteness_penalty'] = max_incompleteness_penalty;
            }
            if (min_score !== undefined) {
                localVarQueryParameter['min_score'] = min_score;
            }
            if (ocw_topic) {
                localVarQueryParameter['ocw_topic'] = ocw_topic;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (search_mode !== undefined) {
                localVarQueryParameter['search_mode'] = search_mode;
            }
            if (slop !== undefined) {
                localVarQueryParameter['slop'] = slop;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic;
            }
            if (yearly_decay_percent !== undefined) {
                localVarQueryParameter['yearly_decay_percent'] = yearly_decay_percent;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Subscribe a user to query
         * @summary Subscribe user to query
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum>} [aggregations] Show resource counts by category
         * @param {boolean | null} [certification] True if the learning resource offers a certificate
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
         * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
         * @param {boolean | null} [free]
         * @param {Array<number>} [id] The id value for the learning resource
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateLevelEnum>} [level]
         * @param {number} [limit] Number of results to return per page
         * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
         * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean | null} [professional]
         * @param {string} [q] The search text
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateResourceCategoryEnum>} [resource_category] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist
         * @param {LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase  * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase
         * @param {number | null} [slop] Allowed distance for phrase search
         * @param {LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum} [source_type] The subscription type  * &#x60;search_subscription_type&#x60; - search_subscription_type * &#x60;channel_subscription_type&#x60; - channel_subscription_type
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
         * @param {PercolateQuerySubscriptionRequestRequest} [PercolateQuerySubscriptionRequestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionSubscribeCreate: (aggregations_3, certification_3, certification_type_3, content_file_score_weight_3, course_feature_3, delivery_3, department_3, dev_mode_3, free_3, id_3, level_3, limit_3, max_incompleteness_penalty_3, min_score_3, ocw_topic_3, offered_by_3, offset_3, platform_3, professional_3, q_3, resource_category_3, resource_type_3, search_mode_3, slop_3, sortby_3, source_type_2, topic_3, yearly_decay_percent_3, PercolateQuerySubscriptionRequestRequest_1, ...args_3) => __awaiter(this, [aggregations_3, certification_3, certification_type_3, content_file_score_weight_3, course_feature_3, delivery_3, department_3, dev_mode_3, free_3, id_3, level_3, limit_3, max_incompleteness_penalty_3, min_score_3, ocw_topic_3, offered_by_3, offset_3, platform_3, professional_3, q_3, resource_category_3, resource_type_3, search_mode_3, slop_3, sortby_3, source_type_2, topic_3, yearly_decay_percent_3, PercolateQuerySubscriptionRequestRequest_1, ...args_3], void 0, function* (aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, source_type, topic, yearly_decay_percent, PercolateQuerySubscriptionRequestRequest, options = {}) {
            const localVarPath = `/api/v1/learning_resources_user_subscription/subscribe/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aggregations) {
                localVarQueryParameter['aggregations'] = aggregations;
            }
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (content_file_score_weight !== undefined) {
                localVarQueryParameter['content_file_score_weight'] = content_file_score_weight;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature;
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (dev_mode !== undefined) {
                localVarQueryParameter['dev_mode'] = dev_mode;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (max_incompleteness_penalty !== undefined) {
                localVarQueryParameter['max_incompleteness_penalty'] = max_incompleteness_penalty;
            }
            if (min_score !== undefined) {
                localVarQueryParameter['min_score'] = min_score;
            }
            if (ocw_topic) {
                localVarQueryParameter['ocw_topic'] = ocw_topic;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (search_mode !== undefined) {
                localVarQueryParameter['search_mode'] = search_mode;
            }
            if (slop !== undefined) {
                localVarQueryParameter['slop'] = slop;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (source_type !== undefined) {
                localVarQueryParameter['source_type'] = source_type;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic;
            }
            if (yearly_decay_percent !== undefined) {
                localVarQueryParameter['yearly_decay_percent'] = yearly_decay_percent;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PercolateQuerySubscriptionRequestRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Unsubscribe a user from a query  Args: pk (integer): The id of the query  Returns: PercolateQuerySerializer: The percolate query
         * @summary Unsubscribe user from query
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionUnsubscribeDestroy: (id_4, ...args_4) => __awaiter(this, [id_4, ...args_4], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningResourcesUserSubscriptionUnsubscribeDestroy', 'id', id);
            const localVarPath = `/api/v1/learning_resources_user_subscription/{id}/unsubscribe/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LearningResourcesUserSubscriptionApi - functional programming interface
 * @export
 */
export const LearningResourcesUserSubscriptionApiFp = function (configuration) {
    const localVarAxiosParamCreator = LearningResourcesUserSubscriptionApiAxiosParamCreator(configuration);
    return {
        /**
         * View for listing percolate query subscriptions for a user
         * @summary Check if a user is subscribed to a specific query
         * @param {Array<LearningResourcesUserSubscriptionCheckListAggregationsEnum>} [aggregations] Show resource counts by category
         * @param {boolean | null} [certification] True if the learning resource offers a certificate
         * @param {Array<LearningResourcesUserSubscriptionCheckListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
         * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
         * @param {Array<LearningResourcesUserSubscriptionCheckListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesUserSubscriptionCheckListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
         * @param {boolean | null} [free]
         * @param {Array<number>} [id] The id value for the learning resource
         * @param {Array<LearningResourcesUserSubscriptionCheckListLevelEnum>} [level]
         * @param {number} [limit] Number of results to return per page
         * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
         * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<LearningResourcesUserSubscriptionCheckListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<LearningResourcesUserSubscriptionCheckListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean | null} [professional]
         * @param {string} [q] The search text
         * @param {Array<LearningResourcesUserSubscriptionCheckListResourceCategoryEnum>} [resource_category] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesUserSubscriptionCheckListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist
         * @param {LearningResourcesUserSubscriptionCheckListSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase  * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase
         * @param {number | null} [slop] Allowed distance for phrase search
         * @param {LearningResourcesUserSubscriptionCheckListSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {LearningResourcesUserSubscriptionCheckListSourceTypeEnum} [source_type] The subscription type  * &#x60;search_subscription_type&#x60; - search_subscription_type * &#x60;channel_subscription_type&#x60; - channel_subscription_type
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionCheckList(aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, source_type, topic, yearly_decay_percent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesUserSubscriptionCheckList(aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, source_type, topic, yearly_decay_percent, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesUserSubscriptionApi.learningResourcesUserSubscriptionCheckList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for listing percolate query subscriptions for a user
         * @summary List subscribed queries
         * @param {Array<LearningResourcesUserSubscriptionListAggregationsEnum>} [aggregations] Show resource counts by category
         * @param {boolean | null} [certification] True if the learning resource offers a certificate
         * @param {Array<LearningResourcesUserSubscriptionListCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
         * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
         * @param {Array<LearningResourcesUserSubscriptionListDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesUserSubscriptionListDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
         * @param {boolean | null} [free]
         * @param {Array<number>} [id] The id value for the learning resource
         * @param {Array<LearningResourcesUserSubscriptionListLevelEnum>} [level]
         * @param {number} [limit] Number of results to return per page
         * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
         * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<LearningResourcesUserSubscriptionListOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<LearningResourcesUserSubscriptionListPlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean | null} [professional]
         * @param {string} [q] The search text
         * @param {Array<LearningResourcesUserSubscriptionListResourceCategoryEnum>} [resource_category] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesUserSubscriptionListResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist
         * @param {LearningResourcesUserSubscriptionListSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase  * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase
         * @param {number | null} [slop] Allowed distance for phrase search
         * @param {LearningResourcesUserSubscriptionListSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionList(aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, topic, yearly_decay_percent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesUserSubscriptionList(aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, topic, yearly_decay_percent, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesUserSubscriptionApi.learningResourcesUserSubscriptionList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Subscribe a user to query
         * @summary Subscribe user to query
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum>} [aggregations] Show resource counts by category
         * @param {boolean | null} [certification] True if the learning resource offers a certificate
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {number | null} [content_file_score_weight] Score weight for content file data.  1 is the default. 0 means content files are ignored
         * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean | null} [dev_mode] If true return raw open search results with score explanations
         * @param {boolean | null} [free]
         * @param {Array<number>} [id] The id value for the learning resource
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateLevelEnum>} [level]
         * @param {number} [limit] Number of results to return per page
         * @param {number | null} [max_incompleteness_penalty] Maximum score penalty for incomplete OCW courses in percent. An OCW course with completeness &#x3D; 0 will have this score penalty. Partially complete courses have a linear penalty proportional to the degree of incompleteness. Only affects results if there is a search term.
         * @param {number | null} [min_score] Minimum score value a text query result needs to have to be displayed
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean | null} [professional]
         * @param {string} [q] The search text
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateResourceCategoryEnum>} [resource_category] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist
         * @param {LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum} [search_mode] The open search search type for text queries               * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase  * &#x60;best_fields&#x60; - best_fields * &#x60;most_fields&#x60; - most_fields * &#x60;phrase&#x60; - phrase
         * @param {number | null} [slop] Allowed distance for phrase search
         * @param {LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum} [sortby] If the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;featured&#x60; - Featured * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum} [source_type] The subscription type  * &#x60;search_subscription_type&#x60; - search_subscription_type * &#x60;channel_subscription_type&#x60; - channel_subscription_type
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {number | null} [yearly_decay_percent] Relevance score penalty percent per year for for resources without upcoming runs. Only affects results if there is a search term.
         * @param {PercolateQuerySubscriptionRequestRequest} [PercolateQuerySubscriptionRequestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionSubscribeCreate(aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, source_type, topic, yearly_decay_percent, PercolateQuerySubscriptionRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesUserSubscriptionSubscribeCreate(aggregations, certification, certification_type, content_file_score_weight, course_feature, delivery, department, dev_mode, free, id, level, limit, max_incompleteness_penalty, min_score, ocw_topic, offered_by, offset, platform, professional, q, resource_category, resource_type, search_mode, slop, sortby, source_type, topic, yearly_decay_percent, PercolateQuerySubscriptionRequestRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesUserSubscriptionApi.learningResourcesUserSubscriptionSubscribeCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Unsubscribe a user from a query  Args: pk (integer): The id of the query  Returns: PercolateQuerySerializer: The percolate query
         * @summary Unsubscribe user from query
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionUnsubscribeDestroy(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesUserSubscriptionUnsubscribeDestroy(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesUserSubscriptionApi.learningResourcesUserSubscriptionUnsubscribeDestroy']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * LearningResourcesUserSubscriptionApi - factory interface
 * @export
 */
export const LearningResourcesUserSubscriptionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LearningResourcesUserSubscriptionApiFp(configuration);
    return {
        /**
         * View for listing percolate query subscriptions for a user
         * @summary Check if a user is subscribed to a specific query
         * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionCheckListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionCheckList(requestParameters = {}, options) {
            return localVarFp.learningResourcesUserSubscriptionCheckList(requestParameters.aggregations, requestParameters.certification, requestParameters.certification_type, requestParameters.content_file_score_weight, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.dev_mode, requestParameters.free, requestParameters.id, requestParameters.level, requestParameters.limit, requestParameters.max_incompleteness_penalty, requestParameters.min_score, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.q, requestParameters.resource_category, requestParameters.resource_type, requestParameters.search_mode, requestParameters.slop, requestParameters.sortby, requestParameters.source_type, requestParameters.topic, requestParameters.yearly_decay_percent, options).then((request) => request(axios, basePath));
        },
        /**
         * View for listing percolate query subscriptions for a user
         * @summary List subscribed queries
         * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionList(requestParameters = {}, options) {
            return localVarFp.learningResourcesUserSubscriptionList(requestParameters.aggregations, requestParameters.certification, requestParameters.certification_type, requestParameters.content_file_score_weight, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.dev_mode, requestParameters.free, requestParameters.id, requestParameters.level, requestParameters.limit, requestParameters.max_incompleteness_penalty, requestParameters.min_score, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.q, requestParameters.resource_category, requestParameters.resource_type, requestParameters.search_mode, requestParameters.slop, requestParameters.sortby, requestParameters.topic, requestParameters.yearly_decay_percent, options).then((request) => request(axios, basePath));
        },
        /**
         * Subscribe a user to query
         * @summary Subscribe user to query
         * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionSubscribeCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionSubscribeCreate(requestParameters = {}, options) {
            return localVarFp.learningResourcesUserSubscriptionSubscribeCreate(requestParameters.aggregations, requestParameters.certification, requestParameters.certification_type, requestParameters.content_file_score_weight, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.dev_mode, requestParameters.free, requestParameters.id, requestParameters.level, requestParameters.limit, requestParameters.max_incompleteness_penalty, requestParameters.min_score, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.q, requestParameters.resource_category, requestParameters.resource_type, requestParameters.search_mode, requestParameters.slop, requestParameters.sortby, requestParameters.source_type, requestParameters.topic, requestParameters.yearly_decay_percent, requestParameters.PercolateQuerySubscriptionRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Unsubscribe a user from a query  Args: pk (integer): The id of the query  Returns: PercolateQuerySerializer: The percolate query
         * @summary Unsubscribe user from query
         * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionUnsubscribeDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesUserSubscriptionUnsubscribeDestroy(requestParameters, options) {
            return localVarFp.learningResourcesUserSubscriptionUnsubscribeDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LearningResourcesUserSubscriptionApi - object-oriented interface
 * @export
 * @class LearningResourcesUserSubscriptionApi
 * @extends {BaseAPI}
 */
export class LearningResourcesUserSubscriptionApi extends BaseAPI {
    /**
     * View for listing percolate query subscriptions for a user
     * @summary Check if a user is subscribed to a specific query
     * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionCheckListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesUserSubscriptionApi
     */
    learningResourcesUserSubscriptionCheckList(requestParameters = {}, options) {
        return LearningResourcesUserSubscriptionApiFp(this.configuration).learningResourcesUserSubscriptionCheckList(requestParameters.aggregations, requestParameters.certification, requestParameters.certification_type, requestParameters.content_file_score_weight, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.dev_mode, requestParameters.free, requestParameters.id, requestParameters.level, requestParameters.limit, requestParameters.max_incompleteness_penalty, requestParameters.min_score, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.q, requestParameters.resource_category, requestParameters.resource_type, requestParameters.search_mode, requestParameters.slop, requestParameters.sortby, requestParameters.source_type, requestParameters.topic, requestParameters.yearly_decay_percent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for listing percolate query subscriptions for a user
     * @summary List subscribed queries
     * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesUserSubscriptionApi
     */
    learningResourcesUserSubscriptionList(requestParameters = {}, options) {
        return LearningResourcesUserSubscriptionApiFp(this.configuration).learningResourcesUserSubscriptionList(requestParameters.aggregations, requestParameters.certification, requestParameters.certification_type, requestParameters.content_file_score_weight, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.dev_mode, requestParameters.free, requestParameters.id, requestParameters.level, requestParameters.limit, requestParameters.max_incompleteness_penalty, requestParameters.min_score, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.q, requestParameters.resource_category, requestParameters.resource_type, requestParameters.search_mode, requestParameters.slop, requestParameters.sortby, requestParameters.topic, requestParameters.yearly_decay_percent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Subscribe a user to query
     * @summary Subscribe user to query
     * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionSubscribeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesUserSubscriptionApi
     */
    learningResourcesUserSubscriptionSubscribeCreate(requestParameters = {}, options) {
        return LearningResourcesUserSubscriptionApiFp(this.configuration).learningResourcesUserSubscriptionSubscribeCreate(requestParameters.aggregations, requestParameters.certification, requestParameters.certification_type, requestParameters.content_file_score_weight, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.dev_mode, requestParameters.free, requestParameters.id, requestParameters.level, requestParameters.limit, requestParameters.max_incompleteness_penalty, requestParameters.min_score, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.q, requestParameters.resource_category, requestParameters.resource_type, requestParameters.search_mode, requestParameters.slop, requestParameters.sortby, requestParameters.source_type, requestParameters.topic, requestParameters.yearly_decay_percent, requestParameters.PercolateQuerySubscriptionRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Unsubscribe a user from a query  Args: pk (integer): The id of the query  Returns: PercolateQuerySerializer: The percolate query
     * @summary Unsubscribe user from query
     * @param {LearningResourcesUserSubscriptionApiLearningResourcesUserSubscriptionUnsubscribeDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesUserSubscriptionApi
     */
    learningResourcesUserSubscriptionUnsubscribeDestroy(requestParameters, options) {
        return LearningResourcesUserSubscriptionApiFp(this.configuration).learningResourcesUserSubscriptionUnsubscribeDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListAggregationsEnum = {
    ResourceType: 'resource_type',
    Certification: 'certification',
    CertificationType: 'certification_type',
    OfferedBy: 'offered_by',
    Platform: 'platform',
    Topic: 'topic',
    Department: 'department',
    Level: 'level',
    CourseFeature: 'course_feature',
    Professional: 'professional',
    Free: 'free',
    Delivery: 'delivery',
    ResourceCategory: 'resource_category'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListCertificationTypeEnum = {
    Micromasters: 'micromasters',
    Professional: 'professional',
    Completion: 'completion',
    None: 'none'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListDepartmentEnum = {
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListLevelEnum = {
    Undergraduate: 'undergraduate',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Noncredit: 'noncredit',
    Advanced: 'advanced',
    Intermediate: 'intermediate',
    Introductory: 'introductory'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListOfferedByEnum = {
    Mitx: 'mitx',
    Ocw: 'ocw',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Mitpe: 'mitpe',
    See: 'see'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListPlatformEnum = {
    Edx: 'edx',
    Ocw: 'ocw',
    Oll: 'oll',
    Mitxonline: 'mitxonline',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Csail: 'csail',
    Mitpe: 'mitpe',
    See: 'see',
    Scc: 'scc',
    Ctl: 'ctl',
    Whu: 'whu',
    Susskind: 'susskind',
    Globalalumni: 'globalalumni',
    Simplilearn: 'simplilearn',
    Emeritus: 'emeritus',
    Podcast: 'podcast',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListResourceCategoryEnum = {
    Course: 'course',
    Program: 'program',
    LearningMaterial: 'learning_material'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListResourceTypeEnum = {
    Course: 'course',
    Program: 'program',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListSearchModeEnum = {
    BestFields: 'best_fields',
    MostFields: 'most_fields',
    Phrase: 'phrase'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListSortbyEnum = {
    Featured: 'featured',
    Id: 'id',
    Id2: '-id',
    ReadableId: 'readable_id',
    ReadableId2: '-readable_id',
    LastModified: 'last_modified',
    LastModified2: '-last_modified',
    New: 'new',
    StartDate: 'start_date',
    StartDate2: '-start_date',
    Mitcoursenumber: 'mitcoursenumber',
    Mitcoursenumber2: '-mitcoursenumber',
    Views: 'views',
    Views2: '-views',
    Upcoming: 'upcoming'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionCheckListSourceTypeEnum = {
    SearchSubscriptionType: 'search_subscription_type',
    ChannelSubscriptionType: 'channel_subscription_type'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionListAggregationsEnum = {
    ResourceType: 'resource_type',
    Certification: 'certification',
    CertificationType: 'certification_type',
    OfferedBy: 'offered_by',
    Platform: 'platform',
    Topic: 'topic',
    Department: 'department',
    Level: 'level',
    CourseFeature: 'course_feature',
    Professional: 'professional',
    Free: 'free',
    Delivery: 'delivery',
    ResourceCategory: 'resource_category'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionListCertificationTypeEnum = {
    Micromasters: 'micromasters',
    Professional: 'professional',
    Completion: 'completion',
    None: 'none'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionListDepartmentEnum = {
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionListLevelEnum = {
    Undergraduate: 'undergraduate',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Noncredit: 'noncredit',
    Advanced: 'advanced',
    Intermediate: 'intermediate',
    Introductory: 'introductory'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionListOfferedByEnum = {
    Mitx: 'mitx',
    Ocw: 'ocw',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Mitpe: 'mitpe',
    See: 'see'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionListPlatformEnum = {
    Edx: 'edx',
    Ocw: 'ocw',
    Oll: 'oll',
    Mitxonline: 'mitxonline',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Csail: 'csail',
    Mitpe: 'mitpe',
    See: 'see',
    Scc: 'scc',
    Ctl: 'ctl',
    Whu: 'whu',
    Susskind: 'susskind',
    Globalalumni: 'globalalumni',
    Simplilearn: 'simplilearn',
    Emeritus: 'emeritus',
    Podcast: 'podcast',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionListResourceCategoryEnum = {
    Course: 'course',
    Program: 'program',
    LearningMaterial: 'learning_material'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionListResourceTypeEnum = {
    Course: 'course',
    Program: 'program',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionListSearchModeEnum = {
    BestFields: 'best_fields',
    MostFields: 'most_fields',
    Phrase: 'phrase'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionListSortbyEnum = {
    Featured: 'featured',
    Id: 'id',
    Id2: '-id',
    ReadableId: 'readable_id',
    ReadableId2: '-readable_id',
    LastModified: 'last_modified',
    LastModified2: '-last_modified',
    New: 'new',
    StartDate: 'start_date',
    StartDate2: '-start_date',
    Mitcoursenumber: 'mitcoursenumber',
    Mitcoursenumber2: '-mitcoursenumber',
    Views: 'views',
    Views2: '-views',
    Upcoming: 'upcoming'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreateAggregationsEnum = {
    ResourceType: 'resource_type',
    Certification: 'certification',
    CertificationType: 'certification_type',
    OfferedBy: 'offered_by',
    Platform: 'platform',
    Topic: 'topic',
    Department: 'department',
    Level: 'level',
    CourseFeature: 'course_feature',
    Professional: 'professional',
    Free: 'free',
    Delivery: 'delivery',
    ResourceCategory: 'resource_category'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreateCertificationTypeEnum = {
    Micromasters: 'micromasters',
    Professional: 'professional',
    Completion: 'completion',
    None: 'none'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreateDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreateDepartmentEnum = {
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreateLevelEnum = {
    Undergraduate: 'undergraduate',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Noncredit: 'noncredit',
    Advanced: 'advanced',
    Intermediate: 'intermediate',
    Introductory: 'introductory'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreateOfferedByEnum = {
    Mitx: 'mitx',
    Ocw: 'ocw',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Mitpe: 'mitpe',
    See: 'see'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreatePlatformEnum = {
    Edx: 'edx',
    Ocw: 'ocw',
    Oll: 'oll',
    Mitxonline: 'mitxonline',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Csail: 'csail',
    Mitpe: 'mitpe',
    See: 'see',
    Scc: 'scc',
    Ctl: 'ctl',
    Whu: 'whu',
    Susskind: 'susskind',
    Globalalumni: 'globalalumni',
    Simplilearn: 'simplilearn',
    Emeritus: 'emeritus',
    Podcast: 'podcast',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreateResourceCategoryEnum = {
    Course: 'course',
    Program: 'program',
    LearningMaterial: 'learning_material'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreateResourceTypeEnum = {
    Course: 'course',
    Program: 'program',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreateSearchModeEnum = {
    BestFields: 'best_fields',
    MostFields: 'most_fields',
    Phrase: 'phrase'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreateSortbyEnum = {
    Featured: 'featured',
    Id: 'id',
    Id2: '-id',
    ReadableId: 'readable_id',
    ReadableId2: '-readable_id',
    LastModified: 'last_modified',
    LastModified2: '-last_modified',
    New: 'new',
    StartDate: 'start_date',
    StartDate2: '-start_date',
    Mitcoursenumber: 'mitcoursenumber',
    Mitcoursenumber2: '-mitcoursenumber',
    Views: 'views',
    Views2: '-views',
    Upcoming: 'upcoming'
};
/**
 * @export
 */
export const LearningResourcesUserSubscriptionSubscribeCreateSourceTypeEnum = {
    SearchSubscriptionType: 'search_subscription_type',
    ChannelSubscriptionType: 'channel_subscription_type'
};
/**
 * LearningpathsApi - axios parameter creator
 * @export
 */
export const LearningpathsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a learning path
         * @summary Create
         * @param {LearningPathResourceRequest} LearningPathResourceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsCreate: (LearningPathResourceRequest_1, ...args_1) => __awaiter(this, [LearningPathResourceRequest_1, ...args_1], void 0, function* (LearningPathResourceRequest, options = {}) {
            // verify required parameter 'LearningPathResourceRequest' is not null or undefined
            assertParamExists('learningpathsCreate', 'LearningPathResourceRequest', LearningPathResourceRequest);
            const localVarPath = `/api/v1/learningpaths/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(LearningPathResourceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Remove a learning path
         * @summary Destroy
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsDestroy: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningpathsDestroy', 'id', id);
            const localVarPath = `/api/v1/learningpaths/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for LearningPath related resources
         * @summary Learning Path Resource Relationship Add
         * @param {number} learning_resource_id The learning resource id of the learning path
         * @param {LearningPathRelationshipRequest} LearningPathRelationshipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsCreate: (learning_resource_id_1, LearningPathRelationshipRequest_1, ...args_3) => __awaiter(this, [learning_resource_id_1, LearningPathRelationshipRequest_1, ...args_3], void 0, function* (learning_resource_id, LearningPathRelationshipRequest, options = {}) {
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('learningpathsItemsCreate', 'learning_resource_id', learning_resource_id);
            // verify required parameter 'LearningPathRelationshipRequest' is not null or undefined
            assertParamExists('learningpathsItemsCreate', 'LearningPathRelationshipRequest', LearningPathRelationshipRequest);
            const localVarPath = `/api/v1/learningpaths/{learning_resource_id}/items/`
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(LearningPathRelationshipRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for LearningPath related resources
         * @summary Learning Path Resource Relationship Remove
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id The learning resource id of the learning path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsDestroy: (id_2, learning_resource_id_2, ...args_4) => __awaiter(this, [id_2, learning_resource_id_2, ...args_4], void 0, function* (id, learning_resource_id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningpathsItemsDestroy', 'id', id);
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('learningpathsItemsDestroy', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/learningpaths/{learning_resource_id}/items/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for LearningPath related resources
         * @param {number} learning_resource_id The learning resource id of the learning path
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [sortby] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsList: (learning_resource_id_3, limit_1, offset_1, sortby_1, ...args_5) => __awaiter(this, [learning_resource_id_3, limit_1, offset_1, sortby_1, ...args_5], void 0, function* (learning_resource_id, limit, offset, sortby, options = {}) {
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('learningpathsItemsList', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/learningpaths/{learning_resource_id}/items/`
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for LearningPath related resources
         * @summary Learning Path Resource Relationship Update
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id The learning resource id of the learning path
         * @param {PatchedLearningPathRelationshipRequest} [PatchedLearningPathRelationshipRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsPartialUpdate: (id_3, learning_resource_id_4, PatchedLearningPathRelationshipRequest_1, ...args_6) => __awaiter(this, [id_3, learning_resource_id_4, PatchedLearningPathRelationshipRequest_1, ...args_6], void 0, function* (id, learning_resource_id, PatchedLearningPathRelationshipRequest, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningpathsItemsPartialUpdate', 'id', id);
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('learningpathsItemsPartialUpdate', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/learningpaths/{learning_resource_id}/items/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PatchedLearningPathRelationshipRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id The learning resource id of the learning path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsRetrieve: (id_4, learning_resource_id_5, ...args_7) => __awaiter(this, [id_4, learning_resource_id_5, ...args_7], void 0, function* (id, learning_resource_id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningpathsItemsRetrieve', 'id', id);
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('learningpathsItemsRetrieve', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/learningpaths/{learning_resource_id}/items/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a paginated list of learning paths
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<LearningpathsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<LearningpathsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningpathsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<LearningpathsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<LearningpathsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<LearningpathsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<LearningpathsListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningpathsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {LearningpathsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsList: (certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_2, offered_by_1, offset_2, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_2, topic_1, ...args_8) => __awaiter(this, [certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_2, offered_by_1, offset_2, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_2, topic_1, ...args_8], void 0, function* (certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            const localVarPath = `/api/v1/learningpaths/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a list of all learning path items
         * @summary List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsMembershipList: (...args_9) => __awaiter(this, [...args_9], void 0, function* (options = {}) {
            const localVarPath = `/api/v1/learningpaths/membership/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update individual fields of a learning path
         * @summary Update
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {PatchedLearningPathResourceRequest} [PatchedLearningPathResourceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsPartialUpdate: (id_5, PatchedLearningPathResourceRequest_1, ...args_10) => __awaiter(this, [id_5, PatchedLearningPathResourceRequest_1, ...args_10], void 0, function* (id, PatchedLearningPathResourceRequest, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningpathsPartialUpdate', 'id', id);
            const localVarPath = `/api/v1/learningpaths/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PatchedLearningPathResourceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrive a single learning path
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsRetrieve: (id_6, ...args_11) => __awaiter(this, [id_6, ...args_11], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('learningpathsRetrieve', 'id', id);
            const localVarPath = `/api/v1/learningpaths/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LearningpathsApi - functional programming interface
 * @export
 */
export const LearningpathsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LearningpathsApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a learning path
         * @summary Create
         * @param {LearningPathResourceRequest} LearningPathResourceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsCreate(LearningPathResourceRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningpathsCreate(LearningPathResourceRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningpathsApi.learningpathsCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Remove a learning path
         * @summary Destroy
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsDestroy(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningpathsDestroy(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningpathsApi.learningpathsDestroy']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for LearningPath related resources
         * @summary Learning Path Resource Relationship Add
         * @param {number} learning_resource_id The learning resource id of the learning path
         * @param {LearningPathRelationshipRequest} LearningPathRelationshipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsCreate(learning_resource_id, LearningPathRelationshipRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningpathsItemsCreate(learning_resource_id, LearningPathRelationshipRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningpathsApi.learningpathsItemsCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for LearningPath related resources
         * @summary Learning Path Resource Relationship Remove
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id The learning resource id of the learning path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsDestroy(id, learning_resource_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningpathsItemsDestroy(id, learning_resource_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningpathsApi.learningpathsItemsDestroy']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for LearningPath related resources
         * @param {number} learning_resource_id The learning resource id of the learning path
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [sortby] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsList(learning_resource_id, limit, offset, sortby, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningpathsItemsList(learning_resource_id, limit, offset, sortby, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningpathsApi.learningpathsItemsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for LearningPath related resources
         * @summary Learning Path Resource Relationship Update
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id The learning resource id of the learning path
         * @param {PatchedLearningPathRelationshipRequest} [PatchedLearningPathRelationshipRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsPartialUpdate(id, learning_resource_id, PatchedLearningPathRelationshipRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningpathsItemsPartialUpdate(id, learning_resource_id, PatchedLearningPathRelationshipRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningpathsApi.learningpathsItemsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id The learning resource id of the learning path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsRetrieve(id, learning_resource_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningpathsItemsRetrieve(id, learning_resource_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningpathsApi.learningpathsItemsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a paginated list of learning paths
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<LearningpathsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<LearningpathsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<LearningpathsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<LearningpathsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<LearningpathsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<LearningpathsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<LearningpathsListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<LearningpathsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {LearningpathsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningpathsList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningpathsApi.learningpathsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a list of all learning path items
         * @summary List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsMembershipList(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningpathsMembershipList(options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningpathsApi.learningpathsMembershipList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Update individual fields of a learning path
         * @summary Update
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {PatchedLearningPathResourceRequest} [PatchedLearningPathResourceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsPartialUpdate(id, PatchedLearningPathResourceRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningpathsPartialUpdate(id, PatchedLearningPathResourceRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningpathsApi.learningpathsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrive a single learning path
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningpathsRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningpathsApi.learningpathsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * LearningpathsApi - factory interface
 * @export
 */
export const LearningpathsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LearningpathsApiFp(configuration);
    return {
        /**
         * Create a learning path
         * @summary Create
         * @param {LearningpathsApiLearningpathsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsCreate(requestParameters, options) {
            return localVarFp.learningpathsCreate(requestParameters.LearningPathResourceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a learning path
         * @summary Destroy
         * @param {LearningpathsApiLearningpathsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsDestroy(requestParameters, options) {
            return localVarFp.learningpathsDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for LearningPath related resources
         * @summary Learning Path Resource Relationship Add
         * @param {LearningpathsApiLearningpathsItemsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsCreate(requestParameters, options) {
            return localVarFp.learningpathsItemsCreate(requestParameters.learning_resource_id, requestParameters.LearningPathRelationshipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for LearningPath related resources
         * @summary Learning Path Resource Relationship Remove
         * @param {LearningpathsApiLearningpathsItemsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsDestroy(requestParameters, options) {
            return localVarFp.learningpathsItemsDestroy(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for LearningPath related resources
         * @param {LearningpathsApiLearningpathsItemsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsList(requestParameters, options) {
            return localVarFp.learningpathsItemsList(requestParameters.learning_resource_id, requestParameters.limit, requestParameters.offset, requestParameters.sortby, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for LearningPath related resources
         * @summary Learning Path Resource Relationship Update
         * @param {LearningpathsApiLearningpathsItemsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsPartialUpdate(requestParameters, options) {
            return localVarFp.learningpathsItemsPartialUpdate(requestParameters.id, requestParameters.learning_resource_id, requestParameters.PatchedLearningPathRelationshipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {LearningpathsApiLearningpathsItemsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsItemsRetrieve(requestParameters, options) {
            return localVarFp.learningpathsItemsRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a paginated list of learning paths
         * @summary List
         * @param {LearningpathsApiLearningpathsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsList(requestParameters = {}, options) {
            return localVarFp.learningpathsList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of all learning path items
         * @summary List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsMembershipList(options) {
            return localVarFp.learningpathsMembershipList(options).then((request) => request(axios, basePath));
        },
        /**
         * Update individual fields of a learning path
         * @summary Update
         * @param {LearningpathsApiLearningpathsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsPartialUpdate(requestParameters, options) {
            return localVarFp.learningpathsPartialUpdate(requestParameters.id, requestParameters.PatchedLearningPathResourceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrive a single learning path
         * @summary Retrieve
         * @param {LearningpathsApiLearningpathsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningpathsRetrieve(requestParameters, options) {
            return localVarFp.learningpathsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LearningpathsApi - object-oriented interface
 * @export
 * @class LearningpathsApi
 * @extends {BaseAPI}
 */
export class LearningpathsApi extends BaseAPI {
    /**
     * Create a learning path
     * @summary Create
     * @param {LearningpathsApiLearningpathsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningpathsApi
     */
    learningpathsCreate(requestParameters, options) {
        return LearningpathsApiFp(this.configuration).learningpathsCreate(requestParameters.LearningPathResourceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a learning path
     * @summary Destroy
     * @param {LearningpathsApiLearningpathsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningpathsApi
     */
    learningpathsDestroy(requestParameters, options) {
        return LearningpathsApiFp(this.configuration).learningpathsDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Add
     * @param {LearningpathsApiLearningpathsItemsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningpathsApi
     */
    learningpathsItemsCreate(requestParameters, options) {
        return LearningpathsApiFp(this.configuration).learningpathsItemsCreate(requestParameters.learning_resource_id, requestParameters.LearningPathRelationshipRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Remove
     * @param {LearningpathsApiLearningpathsItemsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningpathsApi
     */
    learningpathsItemsDestroy(requestParameters, options) {
        return LearningpathsApiFp(this.configuration).learningpathsItemsDestroy(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for LearningPath related resources
     * @param {LearningpathsApiLearningpathsItemsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningpathsApi
     */
    learningpathsItemsList(requestParameters, options) {
        return LearningpathsApiFp(this.configuration).learningpathsItemsList(requestParameters.learning_resource_id, requestParameters.limit, requestParameters.offset, requestParameters.sortby, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for LearningPath related resources
     * @summary Learning Path Resource Relationship Update
     * @param {LearningpathsApiLearningpathsItemsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningpathsApi
     */
    learningpathsItemsPartialUpdate(requestParameters, options) {
        return LearningpathsApiFp(this.configuration).learningpathsItemsPartialUpdate(requestParameters.id, requestParameters.learning_resource_id, requestParameters.PatchedLearningPathRelationshipRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {LearningpathsApiLearningpathsItemsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningpathsApi
     */
    learningpathsItemsRetrieve(requestParameters, options) {
        return LearningpathsApiFp(this.configuration).learningpathsItemsRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a paginated list of learning paths
     * @summary List
     * @param {LearningpathsApiLearningpathsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningpathsApi
     */
    learningpathsList(requestParameters = {}, options) {
        return LearningpathsApiFp(this.configuration).learningpathsList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a list of all learning path items
     * @summary List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningpathsApi
     */
    learningpathsMembershipList(options) {
        return LearningpathsApiFp(this.configuration).learningpathsMembershipList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update individual fields of a learning path
     * @summary Update
     * @param {LearningpathsApiLearningpathsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningpathsApi
     */
    learningpathsPartialUpdate(requestParameters, options) {
        return LearningpathsApiFp(this.configuration).learningpathsPartialUpdate(requestParameters.id, requestParameters.PatchedLearningPathResourceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrive a single learning path
     * @summary Retrieve
     * @param {LearningpathsApiLearningpathsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningpathsApi
     */
    learningpathsRetrieve(requestParameters, options) {
        return LearningpathsApiFp(this.configuration).learningpathsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const LearningpathsListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const LearningpathsListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const LearningpathsListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const LearningpathsListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const LearningpathsListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const LearningpathsListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const LearningpathsListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const LearningpathsListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const LearningpathsListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
/**
 * OfferorsApi - axios parameter creator
 * @export
 */
export const OfferorsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * MIT organizations that offer learning resources
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offerorsList: (limit_1, offset_1, ...args_1) => __awaiter(this, [limit_1, offset_1, ...args_1], void 0, function* (limit, offset, options = {}) {
            const localVarPath = `/api/v1/offerors/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * MIT organizations that offer learning resources
         * @summary Retrieve
         * @param {string} code A unique value identifying this learning resource offeror.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offerorsRetrieve: (code_1, ...args_2) => __awaiter(this, [code_1, ...args_2], void 0, function* (code, options = {}) {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('offerorsRetrieve', 'code', code);
            const localVarPath = `/api/v1/offerors/{code}/`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OfferorsApi - functional programming interface
 * @export
 */
export const OfferorsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OfferorsApiAxiosParamCreator(configuration);
    return {
        /**
         * MIT organizations that offer learning resources
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offerorsList(limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.offerorsList(limit, offset, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['OfferorsApi.offerorsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * MIT organizations that offer learning resources
         * @summary Retrieve
         * @param {string} code A unique value identifying this learning resource offeror.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offerorsRetrieve(code, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.offerorsRetrieve(code, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['OfferorsApi.offerorsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * OfferorsApi - factory interface
 * @export
 */
export const OfferorsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OfferorsApiFp(configuration);
    return {
        /**
         * MIT organizations that offer learning resources
         * @summary List
         * @param {OfferorsApiOfferorsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offerorsList(requestParameters = {}, options) {
            return localVarFp.offerorsList(requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * MIT organizations that offer learning resources
         * @summary Retrieve
         * @param {OfferorsApiOfferorsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offerorsRetrieve(requestParameters, options) {
            return localVarFp.offerorsRetrieve(requestParameters.code, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OfferorsApi - object-oriented interface
 * @export
 * @class OfferorsApi
 * @extends {BaseAPI}
 */
export class OfferorsApi extends BaseAPI {
    /**
     * MIT organizations that offer learning resources
     * @summary List
     * @param {OfferorsApiOfferorsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferorsApi
     */
    offerorsList(requestParameters = {}, options) {
        return OfferorsApiFp(this.configuration).offerorsList(requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * MIT organizations that offer learning resources
     * @summary Retrieve
     * @param {OfferorsApiOfferorsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferorsApi
     */
    offerorsRetrieve(requestParameters, options) {
        return OfferorsApiFp(this.configuration).offerorsRetrieve(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PlatformsApi - axios parameter creator
 * @export
 */
export const PlatformsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Platforms on which learning resources are hosted
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformsList: (limit_1, offset_1, ...args_1) => __awaiter(this, [limit_1, offset_1, ...args_1], void 0, function* (limit, offset, options = {}) {
            const localVarPath = `/api/v1/platforms/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Platforms on which learning resources are hosted
         * @summary Retrieve
         * @param {string} code A unique value identifying this learning resource platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformsRetrieve: (code_1, ...args_2) => __awaiter(this, [code_1, ...args_2], void 0, function* (code, options = {}) {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('platformsRetrieve', 'code', code);
            const localVarPath = `/api/v1/platforms/{code}/`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PlatformsApi - functional programming interface
 * @export
 */
export const PlatformsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PlatformsApiAxiosParamCreator(configuration);
    return {
        /**
         * Platforms on which learning resources are hosted
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformsList(limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.platformsList(limit, offset, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['PlatformsApi.platformsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Platforms on which learning resources are hosted
         * @summary Retrieve
         * @param {string} code A unique value identifying this learning resource platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformsRetrieve(code, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.platformsRetrieve(code, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['PlatformsApi.platformsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * PlatformsApi - factory interface
 * @export
 */
export const PlatformsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PlatformsApiFp(configuration);
    return {
        /**
         * Platforms on which learning resources are hosted
         * @summary List
         * @param {PlatformsApiPlatformsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformsList(requestParameters = {}, options) {
            return localVarFp.platformsList(requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Platforms on which learning resources are hosted
         * @summary Retrieve
         * @param {PlatformsApiPlatformsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformsRetrieve(requestParameters, options) {
            return localVarFp.platformsRetrieve(requestParameters.code, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PlatformsApi - object-oriented interface
 * @export
 * @class PlatformsApi
 * @extends {BaseAPI}
 */
export class PlatformsApi extends BaseAPI {
    /**
     * Platforms on which learning resources are hosted
     * @summary List
     * @param {PlatformsApiPlatformsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformsApi
     */
    platformsList(requestParameters = {}, options) {
        return PlatformsApiFp(this.configuration).platformsList(requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Platforms on which learning resources are hosted
     * @summary Retrieve
     * @param {PlatformsApiPlatformsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformsApi
     */
    platformsRetrieve(requestParameters, options) {
        return PlatformsApiFp(this.configuration).platformsRetrieve(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PodcastEpisodesApi - axios parameter creator
 * @export
 */
export const PodcastEpisodesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a paginated list of podcast episodes
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<PodcastEpisodesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<PodcastEpisodesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<PodcastEpisodesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<PodcastEpisodesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<PodcastEpisodesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<PodcastEpisodesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<PodcastEpisodesListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<PodcastEpisodesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {PodcastEpisodesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastEpisodesList: (certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, offered_by_1, offset_1, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_1) => __awaiter(this, [certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, offered_by_1, offset_1, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_1], void 0, function* (certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            const localVarPath = `/api/v1/podcast_episodes/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a single podcast episode
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastEpisodesRetrieve: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('podcastEpisodesRetrieve', 'id', id);
            const localVarPath = `/api/v1/podcast_episodes/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PodcastEpisodesApi - functional programming interface
 * @export
 */
export const PodcastEpisodesApiFp = function (configuration) {
    const localVarAxiosParamCreator = PodcastEpisodesApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a paginated list of podcast episodes
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<PodcastEpisodesListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<PodcastEpisodesListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<PodcastEpisodesListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<PodcastEpisodesListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<PodcastEpisodesListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<PodcastEpisodesListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<PodcastEpisodesListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<PodcastEpisodesListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {PodcastEpisodesListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastEpisodesList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.podcastEpisodesList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['PodcastEpisodesApi.podcastEpisodesList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a single podcast episode
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastEpisodesRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.podcastEpisodesRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['PodcastEpisodesApi.podcastEpisodesRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * PodcastEpisodesApi - factory interface
 * @export
 */
export const PodcastEpisodesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PodcastEpisodesApiFp(configuration);
    return {
        /**
         * Get a paginated list of podcast episodes
         * @summary List
         * @param {PodcastEpisodesApiPodcastEpisodesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastEpisodesList(requestParameters = {}, options) {
            return localVarFp.podcastEpisodesList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single podcast episode
         * @summary Retrieve
         * @param {PodcastEpisodesApiPodcastEpisodesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastEpisodesRetrieve(requestParameters, options) {
            return localVarFp.podcastEpisodesRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PodcastEpisodesApi - object-oriented interface
 * @export
 * @class PodcastEpisodesApi
 * @extends {BaseAPI}
 */
export class PodcastEpisodesApi extends BaseAPI {
    /**
     * Get a paginated list of podcast episodes
     * @summary List
     * @param {PodcastEpisodesApiPodcastEpisodesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodcastEpisodesApi
     */
    podcastEpisodesList(requestParameters = {}, options) {
        return PodcastEpisodesApiFp(this.configuration).podcastEpisodesList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single podcast episode
     * @summary Retrieve
     * @param {PodcastEpisodesApiPodcastEpisodesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodcastEpisodesApi
     */
    podcastEpisodesRetrieve(requestParameters, options) {
        return PodcastEpisodesApiFp(this.configuration).podcastEpisodesRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const PodcastEpisodesListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const PodcastEpisodesListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const PodcastEpisodesListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const PodcastEpisodesListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const PodcastEpisodesListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const PodcastEpisodesListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const PodcastEpisodesListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const PodcastEpisodesListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const PodcastEpisodesListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
/**
 * PodcastsApi - axios parameter creator
 * @export
 */
export const PodcastsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a list of related learning resources for a learning resource.
         * @summary Nested Learning Resource List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [sortby] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsItemsList: (learning_resource_id_1, limit_1, offset_1, sortby_1, ...args_1) => __awaiter(this, [learning_resource_id_1, limit_1, offset_1, sortby_1, ...args_1], void 0, function* (learning_resource_id, limit, offset, sortby, options = {}) {
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('podcastsItemsList', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/podcasts/{learning_resource_id}/items/`
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsItemsRetrieve: (id_1, learning_resource_id_2, ...args_2) => __awaiter(this, [id_1, learning_resource_id_2, ...args_2], void 0, function* (id, learning_resource_id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('podcastsItemsRetrieve', 'id', id);
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('podcastsItemsRetrieve', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/podcasts/{learning_resource_id}/items/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a paginated list of podcasts
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<PodcastsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<PodcastsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<PodcastsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<PodcastsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<PodcastsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<PodcastsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<PodcastsListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<PodcastsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {PodcastsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsList: (certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_2, offered_by_1, offset_2, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_2, topic_1, ...args_3) => __awaiter(this, [certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_2, offered_by_1, offset_2, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_2, topic_1, ...args_3], void 0, function* (certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            const localVarPath = `/api/v1/podcasts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a single podcast
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsRetrieve: (id_2, ...args_4) => __awaiter(this, [id_2, ...args_4], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('podcastsRetrieve', 'id', id);
            const localVarPath = `/api/v1/podcasts/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PodcastsApi - functional programming interface
 * @export
 */
export const PodcastsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PodcastsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a list of related learning resources for a learning resource.
         * @summary Nested Learning Resource List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [sortby] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsItemsList(learning_resource_id, limit, offset, sortby, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.podcastsItemsList(learning_resource_id, limit, offset, sortby, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['PodcastsApi.podcastsItemsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsItemsRetrieve(id, learning_resource_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.podcastsItemsRetrieve(id, learning_resource_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['PodcastsApi.podcastsItemsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a paginated list of podcasts
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<PodcastsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<PodcastsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<PodcastsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<PodcastsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<PodcastsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<PodcastsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<PodcastsListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<PodcastsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {PodcastsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.podcastsList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['PodcastsApi.podcastsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a single podcast
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.podcastsRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['PodcastsApi.podcastsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * PodcastsApi - factory interface
 * @export
 */
export const PodcastsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PodcastsApiFp(configuration);
    return {
        /**
         * Get a list of related learning resources for a learning resource.
         * @summary Nested Learning Resource List
         * @param {PodcastsApiPodcastsItemsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsItemsList(requestParameters, options) {
            return localVarFp.podcastsItemsList(requestParameters.learning_resource_id, requestParameters.limit, requestParameters.offset, requestParameters.sortby, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {PodcastsApiPodcastsItemsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsItemsRetrieve(requestParameters, options) {
            return localVarFp.podcastsItemsRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a paginated list of podcasts
         * @summary List
         * @param {PodcastsApiPodcastsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsList(requestParameters = {}, options) {
            return localVarFp.podcastsList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single podcast
         * @summary Retrieve
         * @param {PodcastsApiPodcastsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        podcastsRetrieve(requestParameters, options) {
            return localVarFp.podcastsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PodcastsApi - object-oriented interface
 * @export
 * @class PodcastsApi
 * @extends {BaseAPI}
 */
export class PodcastsApi extends BaseAPI {
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {PodcastsApiPodcastsItemsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodcastsApi
     */
    podcastsItemsList(requestParameters, options) {
        return PodcastsApiFp(this.configuration).podcastsItemsList(requestParameters.learning_resource_id, requestParameters.limit, requestParameters.offset, requestParameters.sortby, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {PodcastsApiPodcastsItemsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodcastsApi
     */
    podcastsItemsRetrieve(requestParameters, options) {
        return PodcastsApiFp(this.configuration).podcastsItemsRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a paginated list of podcasts
     * @summary List
     * @param {PodcastsApiPodcastsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodcastsApi
     */
    podcastsList(requestParameters = {}, options) {
        return PodcastsApiFp(this.configuration).podcastsList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single podcast
     * @summary Retrieve
     * @param {PodcastsApiPodcastsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodcastsApi
     */
    podcastsRetrieve(requestParameters, options) {
        return PodcastsApiFp(this.configuration).podcastsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const PodcastsListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const PodcastsListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const PodcastsListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const PodcastsListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const PodcastsListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const PodcastsListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const PodcastsListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const PodcastsListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const PodcastsListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
/**
 * ProgramLettersApi - axios parameter creator
 * @export
 */
export const ProgramLettersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Detail only View for program letters
         * @param {string} id A UUID string identifying this program letter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programLettersRetrieve: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('programLettersRetrieve', 'id', id);
            const localVarPath = `/api/v1/program_letters/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProgramLettersApi - functional programming interface
 * @export
 */
export const ProgramLettersApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProgramLettersApiAxiosParamCreator(configuration);
    return {
        /**
         * Detail only View for program letters
         * @param {string} id A UUID string identifying this program letter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programLettersRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.programLettersRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ProgramLettersApi.programLettersRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ProgramLettersApi - factory interface
 * @export
 */
export const ProgramLettersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProgramLettersApiFp(configuration);
    return {
        /**
         * Detail only View for program letters
         * @param {ProgramLettersApiProgramLettersRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programLettersRetrieve(requestParameters, options) {
            return localVarFp.programLettersRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProgramLettersApi - object-oriented interface
 * @export
 * @class ProgramLettersApi
 * @extends {BaseAPI}
 */
export class ProgramLettersApi extends BaseAPI {
    /**
     * Detail only View for program letters
     * @param {ProgramLettersApiProgramLettersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramLettersApi
     */
    programLettersRetrieve(requestParameters, options) {
        return ProgramLettersApiFp(this.configuration).programLettersRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProgramsApi - axios parameter creator
 * @export
 */
export const ProgramsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a paginated list of programs
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<ProgramsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<ProgramsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<ProgramsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<ProgramsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<ProgramsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<ProgramsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<ProgramsListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<ProgramsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {ProgramsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programsList: (certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, offered_by_1, offset_1, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_1) => __awaiter(this, [certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, offered_by_1, offset_1, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_1], void 0, function* (certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            const localVarPath = `/api/v1/programs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a single program
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programsRetrieve: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('programsRetrieve', 'id', id);
            const localVarPath = `/api/v1/programs/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProgramsApi - functional programming interface
 * @export
 */
export const ProgramsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProgramsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a paginated list of programs
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<ProgramsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<ProgramsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<ProgramsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<ProgramsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<ProgramsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<ProgramsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<ProgramsListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<ProgramsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {ProgramsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programsList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.programsList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ProgramsApi.programsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a single program
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programsRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.programsRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ProgramsApi.programsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ProgramsApi - factory interface
 * @export
 */
export const ProgramsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProgramsApiFp(configuration);
    return {
        /**
         * Get a paginated list of programs
         * @summary List
         * @param {ProgramsApiProgramsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programsList(requestParameters = {}, options) {
            return localVarFp.programsList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single program
         * @summary Retrieve
         * @param {ProgramsApiProgramsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programsRetrieve(requestParameters, options) {
            return localVarFp.programsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProgramsApi - object-oriented interface
 * @export
 * @class ProgramsApi
 * @extends {BaseAPI}
 */
export class ProgramsApi extends BaseAPI {
    /**
     * Get a paginated list of programs
     * @summary List
     * @param {ProgramsApiProgramsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    programsList(requestParameters = {}, options) {
        return ProgramsApiFp(this.configuration).programsList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single program
     * @summary Retrieve
     * @param {ProgramsApiProgramsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramsApi
     */
    programsRetrieve(requestParameters, options) {
        return ProgramsApiFp(this.configuration).programsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const ProgramsListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const ProgramsListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const ProgramsListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const ProgramsListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const ProgramsListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const ProgramsListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const ProgramsListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const ProgramsListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const ProgramsListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
/**
 * SchoolsApi - axios parameter creator
 * @export
 */
export const SchoolsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * MIT schools
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolsList: (limit_1, offset_1, ...args_1) => __awaiter(this, [limit_1, offset_1, ...args_1], void 0, function* (limit, offset, options = {}) {
            const localVarPath = `/api/v1/schools/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * MIT schools
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource school.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolsRetrieve: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('schoolsRetrieve', 'id', id);
            const localVarPath = `/api/v1/schools/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SchoolsApi - functional programming interface
 * @export
 */
export const SchoolsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SchoolsApiAxiosParamCreator(configuration);
    return {
        /**
         * MIT schools
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolsList(limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schoolsList(limit, offset, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SchoolsApi.schoolsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * MIT schools
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource school.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolsRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schoolsRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SchoolsApi.schoolsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * SchoolsApi - factory interface
 * @export
 */
export const SchoolsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SchoolsApiFp(configuration);
    return {
        /**
         * MIT schools
         * @summary List
         * @param {SchoolsApiSchoolsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolsList(requestParameters = {}, options) {
            return localVarFp.schoolsList(requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * MIT schools
         * @summary Retrieve
         * @param {SchoolsApiSchoolsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schoolsRetrieve(requestParameters, options) {
            return localVarFp.schoolsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SchoolsApi - object-oriented interface
 * @export
 * @class SchoolsApi
 * @extends {BaseAPI}
 */
export class SchoolsApi extends BaseAPI {
    /**
     * MIT schools
     * @summary List
     * @param {SchoolsApiSchoolsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    schoolsList(requestParameters = {}, options) {
        return SchoolsApiFp(this.configuration).schoolsList(requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * MIT schools
     * @summary Retrieve
     * @param {SchoolsApiSchoolsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchoolsApi
     */
    schoolsRetrieve(requestParameters, options) {
        return SchoolsApiFp(this.configuration).schoolsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TopicsApi - axios parameter creator
 * @export
 */
export const TopicsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Topics covered by learning resources
         * @summary List
         * @param {boolean} [is_toplevel] Filter top-level topics
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<string>} [name] Multiple values may be separated by commas.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<number>} [parent_topic_id] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicsList: (is_toplevel_1, limit_1, name_1, offset_1, parent_topic_id_1, ...args_1) => __awaiter(this, [is_toplevel_1, limit_1, name_1, offset_1, parent_topic_id_1, ...args_1], void 0, function* (is_toplevel, limit, name, offset, parent_topic_id, options = {}) {
            const localVarPath = `/api/v1/topics/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (is_toplevel !== undefined) {
                localVarQueryParameter['is_toplevel'] = is_toplevel;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (name) {
                localVarQueryParameter['name'] = name.join(COLLECTION_FORMATS.csv);
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (parent_topic_id) {
                localVarQueryParameter['parent_topic_id'] = parent_topic_id.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Topics covered by learning resources
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource topic.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicsRetrieve: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('topicsRetrieve', 'id', id);
            const localVarPath = `/api/v1/topics/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TopicsApi - functional programming interface
 * @export
 */
export const TopicsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TopicsApiAxiosParamCreator(configuration);
    return {
        /**
         * Topics covered by learning resources
         * @summary List
         * @param {boolean} [is_toplevel] Filter top-level topics
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<string>} [name] Multiple values may be separated by commas.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<number>} [parent_topic_id] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicsList(is_toplevel, limit, name, offset, parent_topic_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.topicsList(is_toplevel, limit, name, offset, parent_topic_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TopicsApi.topicsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Topics covered by learning resources
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource topic.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicsRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.topicsRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TopicsApi.topicsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * TopicsApi - factory interface
 * @export
 */
export const TopicsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TopicsApiFp(configuration);
    return {
        /**
         * Topics covered by learning resources
         * @summary List
         * @param {TopicsApiTopicsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicsList(requestParameters = {}, options) {
            return localVarFp.topicsList(requestParameters.is_toplevel, requestParameters.limit, requestParameters.name, requestParameters.offset, requestParameters.parent_topic_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Topics covered by learning resources
         * @summary Retrieve
         * @param {TopicsApiTopicsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topicsRetrieve(requestParameters, options) {
            return localVarFp.topicsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TopicsApi - object-oriented interface
 * @export
 * @class TopicsApi
 * @extends {BaseAPI}
 */
export class TopicsApi extends BaseAPI {
    /**
     * Topics covered by learning resources
     * @summary List
     * @param {TopicsApiTopicsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    topicsList(requestParameters = {}, options) {
        return TopicsApiFp(this.configuration).topicsList(requestParameters.is_toplevel, requestParameters.limit, requestParameters.name, requestParameters.offset, requestParameters.parent_topic_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Topics covered by learning resources
     * @summary Retrieve
     * @param {TopicsApiTopicsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    topicsRetrieve(requestParameters, options) {
        return TopicsApiFp(this.configuration).topicsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserlistsApi - axios parameter creator
 * @export
 */
export const UserlistsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Viewset for UserLists
         * @summary Create
         * @param {UserListRequest} UserListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsCreate: (UserListRequest_1, ...args_1) => __awaiter(this, [UserListRequest_1, ...args_1], void 0, function* (UserListRequest, options = {}) {
            // verify required parameter 'UserListRequest' is not null or undefined
            assertParamExists('userlistsCreate', 'UserListRequest', UserListRequest);
            const localVarPath = `/api/v1/userlists/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(UserListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for UserLists
         * @summary Destroy
         * @param {number} id A unique integer value identifying this user list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsDestroy: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userlistsDestroy', 'id', id);
            const localVarPath = `/api/v1/userlists/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for UserListRelationships
         * @summary User List Resource Relationship Add
         * @param {number} userlist_id id of the parent user list
         * @param {UserListRelationshipRequest} UserListRelationshipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsCreate: (userlist_id_1, UserListRelationshipRequest_1, ...args_3) => __awaiter(this, [userlist_id_1, UserListRelationshipRequest_1, ...args_3], void 0, function* (userlist_id, UserListRelationshipRequest, options = {}) {
            // verify required parameter 'userlist_id' is not null or undefined
            assertParamExists('userlistsItemsCreate', 'userlist_id', userlist_id);
            // verify required parameter 'UserListRelationshipRequest' is not null or undefined
            assertParamExists('userlistsItemsCreate', 'UserListRelationshipRequest', UserListRelationshipRequest);
            const localVarPath = `/api/v1/userlists/{userlist_id}/items/`
                .replace(`{${"userlist_id"}}`, encodeURIComponent(String(userlist_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(UserListRelationshipRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for UserListRelationships
         * @summary User List Resource Relationship Remove
         * @param {number} id A unique integer value identifying this user list relationship.
         * @param {number} userlist_id id of the parent user list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsDestroy: (id_2, userlist_id_2, ...args_4) => __awaiter(this, [id_2, userlist_id_2, ...args_4], void 0, function* (id, userlist_id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userlistsItemsDestroy', 'id', id);
            // verify required parameter 'userlist_id' is not null or undefined
            assertParamExists('userlistsItemsDestroy', 'userlist_id', userlist_id);
            const localVarPath = `/api/v1/userlists/{userlist_id}/items/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userlist_id"}}`, encodeURIComponent(String(userlist_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for UserListRelationships
         * @summary User List Resources List
         * @param {number} userlist_id id of the parent user list
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsList: (userlist_id_3, limit_1, offset_1, ...args_5) => __awaiter(this, [userlist_id_3, limit_1, offset_1, ...args_5], void 0, function* (userlist_id, limit, offset, options = {}) {
            // verify required parameter 'userlist_id' is not null or undefined
            assertParamExists('userlistsItemsList', 'userlist_id', userlist_id);
            const localVarPath = `/api/v1/userlists/{userlist_id}/items/`
                .replace(`{${"userlist_id"}}`, encodeURIComponent(String(userlist_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for UserListRelationships
         * @summary User List Resource Relationship Update
         * @param {number} id A unique integer value identifying this user list relationship.
         * @param {number} userlist_id id of the parent user list
         * @param {PatchedUserListRelationshipRequest} [PatchedUserListRelationshipRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsPartialUpdate: (id_3, userlist_id_4, PatchedUserListRelationshipRequest_1, ...args_6) => __awaiter(this, [id_3, userlist_id_4, PatchedUserListRelationshipRequest_1, ...args_6], void 0, function* (id, userlist_id, PatchedUserListRelationshipRequest, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userlistsItemsPartialUpdate', 'id', id);
            // verify required parameter 'userlist_id' is not null or undefined
            assertParamExists('userlistsItemsPartialUpdate', 'userlist_id', userlist_id);
            const localVarPath = `/api/v1/userlists/{userlist_id}/items/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userlist_id"}}`, encodeURIComponent(String(userlist_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PatchedUserListRelationshipRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for UserListRelationships
         * @summary User List Resources Retrieve
         * @param {number} id A unique integer value identifying this user list relationship.
         * @param {number} userlist_id id of the parent user list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsRetrieve: (id_4, userlist_id_5, ...args_7) => __awaiter(this, [id_4, userlist_id_5, ...args_7], void 0, function* (id, userlist_id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userlistsItemsRetrieve', 'id', id);
            // verify required parameter 'userlist_id' is not null or undefined
            assertParamExists('userlistsItemsRetrieve', 'userlist_id', userlist_id);
            const localVarPath = `/api/v1/userlists/{userlist_id}/items/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userlist_id"}}`, encodeURIComponent(String(userlist_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for UserLists
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsList: (limit_2, offset_2, ...args_8) => __awaiter(this, [limit_2, offset_2, ...args_8], void 0, function* (limit, offset, options = {}) {
            const localVarPath = `/api/v1/userlists/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a list of all userlist items for a user
         * @summary List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsMembershipList: (...args_9) => __awaiter(this, [...args_9], void 0, function* (options = {}) {
            const localVarPath = `/api/v1/userlists/membership/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for UserLists
         * @summary Update
         * @param {number} id A unique integer value identifying this user list.
         * @param {PatchedUserListRequest} [PatchedUserListRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsPartialUpdate: (id_5, PatchedUserListRequest_1, ...args_10) => __awaiter(this, [id_5, PatchedUserListRequest_1, ...args_10], void 0, function* (id, PatchedUserListRequest, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userlistsPartialUpdate', 'id', id);
            const localVarPath = `/api/v1/userlists/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PatchedUserListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Viewset for UserLists
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this user list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsRetrieve: (id_6, ...args_11) => __awaiter(this, [id_6, ...args_11], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userlistsRetrieve', 'id', id);
            const localVarPath = `/api/v1/userlists/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UserlistsApi - functional programming interface
 * @export
 */
export const UserlistsApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserlistsApiAxiosParamCreator(configuration);
    return {
        /**
         * Viewset for UserLists
         * @summary Create
         * @param {UserListRequest} UserListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsCreate(UserListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userlistsCreate(UserListRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserlistsApi.userlistsCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for UserLists
         * @summary Destroy
         * @param {number} id A unique integer value identifying this user list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsDestroy(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userlistsDestroy(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserlistsApi.userlistsDestroy']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for UserListRelationships
         * @summary User List Resource Relationship Add
         * @param {number} userlist_id id of the parent user list
         * @param {UserListRelationshipRequest} UserListRelationshipRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsCreate(userlist_id, UserListRelationshipRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userlistsItemsCreate(userlist_id, UserListRelationshipRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserlistsApi.userlistsItemsCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for UserListRelationships
         * @summary User List Resource Relationship Remove
         * @param {number} id A unique integer value identifying this user list relationship.
         * @param {number} userlist_id id of the parent user list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsDestroy(id, userlist_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userlistsItemsDestroy(id, userlist_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserlistsApi.userlistsItemsDestroy']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for UserListRelationships
         * @summary User List Resources List
         * @param {number} userlist_id id of the parent user list
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsList(userlist_id, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userlistsItemsList(userlist_id, limit, offset, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserlistsApi.userlistsItemsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for UserListRelationships
         * @summary User List Resource Relationship Update
         * @param {number} id A unique integer value identifying this user list relationship.
         * @param {number} userlist_id id of the parent user list
         * @param {PatchedUserListRelationshipRequest} [PatchedUserListRelationshipRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsPartialUpdate(id, userlist_id, PatchedUserListRelationshipRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userlistsItemsPartialUpdate(id, userlist_id, PatchedUserListRelationshipRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserlistsApi.userlistsItemsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for UserListRelationships
         * @summary User List Resources Retrieve
         * @param {number} id A unique integer value identifying this user list relationship.
         * @param {number} userlist_id id of the parent user list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsRetrieve(id, userlist_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userlistsItemsRetrieve(id, userlist_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserlistsApi.userlistsItemsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for UserLists
         * @summary List
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsList(limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userlistsList(limit, offset, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserlistsApi.userlistsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a list of all userlist items for a user
         * @summary List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsMembershipList(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userlistsMembershipList(options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserlistsApi.userlistsMembershipList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for UserLists
         * @summary Update
         * @param {number} id A unique integer value identifying this user list.
         * @param {PatchedUserListRequest} [PatchedUserListRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsPartialUpdate(id, PatchedUserListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userlistsPartialUpdate(id, PatchedUserListRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserlistsApi.userlistsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Viewset for UserLists
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this user list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userlistsRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserlistsApi.userlistsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * UserlistsApi - factory interface
 * @export
 */
export const UserlistsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserlistsApiFp(configuration);
    return {
        /**
         * Viewset for UserLists
         * @summary Create
         * @param {UserlistsApiUserlistsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsCreate(requestParameters, options) {
            return localVarFp.userlistsCreate(requestParameters.UserListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for UserLists
         * @summary Destroy
         * @param {UserlistsApiUserlistsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsDestroy(requestParameters, options) {
            return localVarFp.userlistsDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for UserListRelationships
         * @summary User List Resource Relationship Add
         * @param {UserlistsApiUserlistsItemsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsCreate(requestParameters, options) {
            return localVarFp.userlistsItemsCreate(requestParameters.userlist_id, requestParameters.UserListRelationshipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for UserListRelationships
         * @summary User List Resource Relationship Remove
         * @param {UserlistsApiUserlistsItemsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsDestroy(requestParameters, options) {
            return localVarFp.userlistsItemsDestroy(requestParameters.id, requestParameters.userlist_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for UserListRelationships
         * @summary User List Resources List
         * @param {UserlistsApiUserlistsItemsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsList(requestParameters, options) {
            return localVarFp.userlistsItemsList(requestParameters.userlist_id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for UserListRelationships
         * @summary User List Resource Relationship Update
         * @param {UserlistsApiUserlistsItemsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsPartialUpdate(requestParameters, options) {
            return localVarFp.userlistsItemsPartialUpdate(requestParameters.id, requestParameters.userlist_id, requestParameters.PatchedUserListRelationshipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for UserListRelationships
         * @summary User List Resources Retrieve
         * @param {UserlistsApiUserlistsItemsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsItemsRetrieve(requestParameters, options) {
            return localVarFp.userlistsItemsRetrieve(requestParameters.id, requestParameters.userlist_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for UserLists
         * @summary List
         * @param {UserlistsApiUserlistsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsList(requestParameters = {}, options) {
            return localVarFp.userlistsList(requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of all userlist items for a user
         * @summary List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsMembershipList(options) {
            return localVarFp.userlistsMembershipList(options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for UserLists
         * @summary Update
         * @param {UserlistsApiUserlistsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsPartialUpdate(requestParameters, options) {
            return localVarFp.userlistsPartialUpdate(requestParameters.id, requestParameters.PatchedUserListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for UserLists
         * @summary Retrieve
         * @param {UserlistsApiUserlistsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userlistsRetrieve(requestParameters, options) {
            return localVarFp.userlistsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserlistsApi - object-oriented interface
 * @export
 * @class UserlistsApi
 * @extends {BaseAPI}
 */
export class UserlistsApi extends BaseAPI {
    /**
     * Viewset for UserLists
     * @summary Create
     * @param {UserlistsApiUserlistsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserlistsApi
     */
    userlistsCreate(requestParameters, options) {
        return UserlistsApiFp(this.configuration).userlistsCreate(requestParameters.UserListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for UserLists
     * @summary Destroy
     * @param {UserlistsApiUserlistsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserlistsApi
     */
    userlistsDestroy(requestParameters, options) {
        return UserlistsApiFp(this.configuration).userlistsDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Add
     * @param {UserlistsApiUserlistsItemsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserlistsApi
     */
    userlistsItemsCreate(requestParameters, options) {
        return UserlistsApiFp(this.configuration).userlistsItemsCreate(requestParameters.userlist_id, requestParameters.UserListRelationshipRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Remove
     * @param {UserlistsApiUserlistsItemsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserlistsApi
     */
    userlistsItemsDestroy(requestParameters, options) {
        return UserlistsApiFp(this.configuration).userlistsItemsDestroy(requestParameters.id, requestParameters.userlist_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for UserListRelationships
     * @summary User List Resources List
     * @param {UserlistsApiUserlistsItemsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserlistsApi
     */
    userlistsItemsList(requestParameters, options) {
        return UserlistsApiFp(this.configuration).userlistsItemsList(requestParameters.userlist_id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for UserListRelationships
     * @summary User List Resource Relationship Update
     * @param {UserlistsApiUserlistsItemsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserlistsApi
     */
    userlistsItemsPartialUpdate(requestParameters, options) {
        return UserlistsApiFp(this.configuration).userlistsItemsPartialUpdate(requestParameters.id, requestParameters.userlist_id, requestParameters.PatchedUserListRelationshipRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for UserListRelationships
     * @summary User List Resources Retrieve
     * @param {UserlistsApiUserlistsItemsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserlistsApi
     */
    userlistsItemsRetrieve(requestParameters, options) {
        return UserlistsApiFp(this.configuration).userlistsItemsRetrieve(requestParameters.id, requestParameters.userlist_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for UserLists
     * @summary List
     * @param {UserlistsApiUserlistsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserlistsApi
     */
    userlistsList(requestParameters = {}, options) {
        return UserlistsApiFp(this.configuration).userlistsList(requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a list of all userlist items for a user
     * @summary List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserlistsApi
     */
    userlistsMembershipList(options) {
        return UserlistsApiFp(this.configuration).userlistsMembershipList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for UserLists
     * @summary Update
     * @param {UserlistsApiUserlistsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserlistsApi
     */
    userlistsPartialUpdate(requestParameters, options) {
        return UserlistsApiFp(this.configuration).userlistsPartialUpdate(requestParameters.id, requestParameters.PatchedUserListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Viewset for UserLists
     * @summary Retrieve
     * @param {UserlistsApiUserlistsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserlistsApi
     */
    userlistsRetrieve(requestParameters, options) {
        return UserlistsApiFp(this.configuration).userlistsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VideoPlaylistsApi - axios parameter creator
 * @export
 */
export const VideoPlaylistsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a list of related learning resources for a learning resource.
         * @summary Nested Learning Resource List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [sortby] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsItemsList: (learning_resource_id_1, limit_1, offset_1, sortby_1, ...args_1) => __awaiter(this, [learning_resource_id_1, limit_1, offset_1, sortby_1, ...args_1], void 0, function* (learning_resource_id, limit, offset, sortby, options = {}) {
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('videoPlaylistsItemsList', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/video_playlists/{learning_resource_id}/items/`
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsItemsRetrieve: (id_1, learning_resource_id_2, ...args_2) => __awaiter(this, [id_1, learning_resource_id_2, ...args_2], void 0, function* (id, learning_resource_id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('videoPlaylistsItemsRetrieve', 'id', id);
            // verify required parameter 'learning_resource_id' is not null or undefined
            assertParamExists('videoPlaylistsItemsRetrieve', 'learning_resource_id', learning_resource_id);
            const localVarPath = `/api/v1/video_playlists/{learning_resource_id}/items/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"learning_resource_id"}}`, encodeURIComponent(String(learning_resource_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a paginated list of video playlists
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<VideoPlaylistsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<VideoPlaylistsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<VideoPlaylistsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<VideoPlaylistsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<VideoPlaylistsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<VideoPlaylistsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<VideoPlaylistsListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<VideoPlaylistsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {VideoPlaylistsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsList: (certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_2, offered_by_1, offset_2, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_2, topic_1, ...args_3) => __awaiter(this, [certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_2, offered_by_1, offset_2, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_2, topic_1, ...args_3], void 0, function* (certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            const localVarPath = `/api/v1/video_playlists/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a single video playlist
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsRetrieve: (id_2, ...args_4) => __awaiter(this, [id_2, ...args_4], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('videoPlaylistsRetrieve', 'id', id);
            const localVarPath = `/api/v1/video_playlists/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VideoPlaylistsApi - functional programming interface
 * @export
 */
export const VideoPlaylistsApiFp = function (configuration) {
    const localVarAxiosParamCreator = VideoPlaylistsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a list of related learning resources for a learning resource.
         * @summary Nested Learning Resource List
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [sortby] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsItemsList(learning_resource_id, limit, offset, sortby, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.videoPlaylistsItemsList(learning_resource_id, limit, offset, sortby, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['VideoPlaylistsApi.videoPlaylistsItemsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {number} id A unique integer value identifying this learning resource relationship.
         * @param {number} learning_resource_id id of the parent learning resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsItemsRetrieve(id, learning_resource_id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.videoPlaylistsItemsRetrieve(id, learning_resource_id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['VideoPlaylistsApi.videoPlaylistsItemsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get a paginated list of video playlists
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<VideoPlaylistsListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<VideoPlaylistsListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<VideoPlaylistsListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<VideoPlaylistsListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<VideoPlaylistsListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<VideoPlaylistsListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<VideoPlaylistsListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<VideoPlaylistsListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {VideoPlaylistsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.videoPlaylistsList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['VideoPlaylistsApi.videoPlaylistsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a single video playlist
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.videoPlaylistsRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['VideoPlaylistsApi.videoPlaylistsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * VideoPlaylistsApi - factory interface
 * @export
 */
export const VideoPlaylistsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VideoPlaylistsApiFp(configuration);
    return {
        /**
         * Get a list of related learning resources for a learning resource.
         * @summary Nested Learning Resource List
         * @param {VideoPlaylistsApiVideoPlaylistsItemsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsItemsList(requestParameters, options) {
            return localVarFp.videoPlaylistsItemsList(requestParameters.learning_resource_id, requestParameters.limit, requestParameters.offset, requestParameters.sortby, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a singe related learning resource for a learning resource.
         * @summary Nested Learning Resource Retrieve
         * @param {VideoPlaylistsApiVideoPlaylistsItemsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsItemsRetrieve(requestParameters, options) {
            return localVarFp.videoPlaylistsItemsRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a paginated list of video playlists
         * @summary List
         * @param {VideoPlaylistsApiVideoPlaylistsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsList(requestParameters = {}, options) {
            return localVarFp.videoPlaylistsList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single video playlist
         * @summary Retrieve
         * @param {VideoPlaylistsApiVideoPlaylistsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoPlaylistsRetrieve(requestParameters, options) {
            return localVarFp.videoPlaylistsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VideoPlaylistsApi - object-oriented interface
 * @export
 * @class VideoPlaylistsApi
 * @extends {BaseAPI}
 */
export class VideoPlaylistsApi extends BaseAPI {
    /**
     * Get a list of related learning resources for a learning resource.
     * @summary Nested Learning Resource List
     * @param {VideoPlaylistsApiVideoPlaylistsItemsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoPlaylistsApi
     */
    videoPlaylistsItemsList(requestParameters, options) {
        return VideoPlaylistsApiFp(this.configuration).videoPlaylistsItemsList(requestParameters.learning_resource_id, requestParameters.limit, requestParameters.offset, requestParameters.sortby, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a singe related learning resource for a learning resource.
     * @summary Nested Learning Resource Retrieve
     * @param {VideoPlaylistsApiVideoPlaylistsItemsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoPlaylistsApi
     */
    videoPlaylistsItemsRetrieve(requestParameters, options) {
        return VideoPlaylistsApiFp(this.configuration).videoPlaylistsItemsRetrieve(requestParameters.id, requestParameters.learning_resource_id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a paginated list of video playlists
     * @summary List
     * @param {VideoPlaylistsApiVideoPlaylistsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoPlaylistsApi
     */
    videoPlaylistsList(requestParameters = {}, options) {
        return VideoPlaylistsApiFp(this.configuration).videoPlaylistsList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single video playlist
     * @summary Retrieve
     * @param {VideoPlaylistsApiVideoPlaylistsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideoPlaylistsApi
     */
    videoPlaylistsRetrieve(requestParameters, options) {
        return VideoPlaylistsApiFp(this.configuration).videoPlaylistsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const VideoPlaylistsListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const VideoPlaylistsListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const VideoPlaylistsListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const VideoPlaylistsListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const VideoPlaylistsListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const VideoPlaylistsListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const VideoPlaylistsListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const VideoPlaylistsListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const VideoPlaylistsListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
/**
 * VideosApi - axios parameter creator
 * @export
 */
export const VideosApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a paginated list of videos
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<VideosListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<VideosListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<VideosListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<VideosListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<VideosListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<VideosListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<VideosListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<VideosListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {VideosListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videosList: (certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, offered_by_1, offset_1, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_1) => __awaiter(this, [certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, offered_by_1, offset_1, platform_1, professional_1, readable_id_1, resource_category_1, resource_type_1, sortby_1, topic_1, ...args_1], void 0, function* (certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options = {}) {
            const localVarPath = `/api/v1/videos/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature.join(COLLECTION_FORMATS.csv);
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (readable_id) {
                localVarQueryParameter['readable_id'] = readable_id.join(COLLECTION_FORMATS.csv);
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a single video
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videosRetrieve: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('videosRetrieve', 'id', id);
            const localVarPath = `/api/v1/videos/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VideosApi - functional programming interface
 * @export
 */
export const VideosApiFp = function (configuration) {
    const localVarAxiosParamCreator = VideosApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a paginated list of videos
         * @summary List
         * @param {boolean} [certification]
         * @param {Array<VideosListCertificationTypeEnum>} [certification_type] The type of certification offered  * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] Multiple values may be separated by commas.
         * @param {Array<Array<VideosListDeliveryEnum>>} [delivery] The delivery of course/program resources  * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<VideosListDepartmentEnum>} [department] The department that offers learning resources  * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean} [free] The course/program is offered for free
         * @param {Array<VideosListLevelEnum>} [level] The academic level of the resources  * &#x60;undergraduate&#x60; - Undergraduate * &#x60;graduate&#x60; - Graduate * &#x60;high_school&#x60; - High School * &#x60;noncredit&#x60; - Non-Credit * &#x60;advanced&#x60; - Advanced * &#x60;intermediate&#x60; - Intermediate * &#x60;introductory&#x60; - Introductory
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<VideosListOfferedByEnum>} [offered_by] The organization that offers a learning resource  * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results.
         * @param {Array<VideosListPlatformEnum>} [platform] The platform on which learning resources are offered  * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean} [professional]
         * @param {Array<string>} [readable_id] Multiple values may be separated by commas.
         * @param {Array<VideosListResourceCategoryEnum>} [resource_category] The resource category of the learning resources  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<VideosListResourceTypeEnum>} [resource_type] The type of learning resource  * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_path&#x60; - Learning Path * &#x60;podcast&#x60; - Podcast * &#x60;podcast_episode&#x60; - Podcast Episode * &#x60;video&#x60; - Video * &#x60;video_playlist&#x60; - Video Playlist
         * @param {VideosListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;readable_id&#x60; - Readable ID ascending * &#x60;-readable_id&#x60; - Readable ID descending * &#x60;last_modified&#x60; - Last Modified Date ascending * &#x60;-last_modified&#x60; - Last Modified Date descending * &#x60;new&#x60; - Newest resources first * &#x60;start_date&#x60; - Start Date ascending * &#x60;-start_date&#x60; - Start Date descending * &#x60;mitcoursenumber&#x60; - MIT course number ascending * &#x60;-mitcoursenumber&#x60; - MIT course number descending * &#x60;views&#x60; - Popularity ascending * &#x60;-views&#x60; - Popularity descending * &#x60;upcoming&#x60; - Next start date ascending
         * @param {Array<string>} [topic] Multiple values may be separated by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videosList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.videosList(certification, certification_type, course_feature, delivery, department, free, level, limit, offered_by, offset, platform, professional, readable_id, resource_category, resource_type, sortby, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['VideosApi.videosList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a single video
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this learning resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videosRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.videosRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['VideosApi.videosRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * VideosApi - factory interface
 * @export
 */
export const VideosApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VideosApiFp(configuration);
    return {
        /**
         * Get a paginated list of videos
         * @summary List
         * @param {VideosApiVideosListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videosList(requestParameters = {}, options) {
            return localVarFp.videosList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single video
         * @summary Retrieve
         * @param {VideosApiVideosRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videosRetrieve(requestParameters, options) {
            return localVarFp.videosRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VideosApi - object-oriented interface
 * @export
 * @class VideosApi
 * @extends {BaseAPI}
 */
export class VideosApi extends BaseAPI {
    /**
     * Get a paginated list of videos
     * @summary List
     * @param {VideosApiVideosListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideosApi
     */
    videosList(requestParameters = {}, options) {
        return VideosApiFp(this.configuration).videosList(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.sortby, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single video
     * @summary Retrieve
     * @param {VideosApiVideosRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VideosApi
     */
    videosRetrieve(requestParameters, options) {
        return VideosApiFp(this.configuration).videosRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const VideosListCertificationTypeEnum = {
    Completion: 'completion',
    Micromasters: 'micromasters',
    None: 'none',
    Professional: 'professional'
};
/**
 * @export
 */
export const VideosListDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const VideosListDepartmentEnum = {
    _1: '1',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _2: '2',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const VideosListLevelEnum = {
    Advanced: 'advanced',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Intermediate: 'intermediate',
    Introductory: 'introductory',
    Noncredit: 'noncredit',
    Undergraduate: 'undergraduate'
};
/**
 * @export
 */
export const VideosListOfferedByEnum = {
    Bootcamps: 'bootcamps',
    Mitpe: 'mitpe',
    Mitx: 'mitx',
    Ocw: 'ocw',
    See: 'see',
    Xpro: 'xpro'
};
/**
 * @export
 */
export const VideosListPlatformEnum = {
    Bootcamps: 'bootcamps',
    Csail: 'csail',
    Ctl: 'ctl',
    Edx: 'edx',
    Emeritus: 'emeritus',
    Globalalumni: 'globalalumni',
    Mitpe: 'mitpe',
    Mitxonline: 'mitxonline',
    Ocw: 'ocw',
    Oll: 'oll',
    Podcast: 'podcast',
    Scc: 'scc',
    See: 'see',
    Simplilearn: 'simplilearn',
    Susskind: 'susskind',
    Whu: 'whu',
    Xpro: 'xpro',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const VideosListResourceCategoryEnum = {
    Course: 'course',
    LearningMaterial: 'learning_material',
    Program: 'program'
};
/**
 * @export
 */
export const VideosListResourceTypeEnum = {
    Course: 'course',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Program: 'program',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * @export
 */
export const VideosListSortbyEnum = {
    Id: '-id',
    LastModified: '-last_modified',
    Mitcoursenumber: '-mitcoursenumber',
    ReadableId: '-readable_id',
    StartDate: '-start_date',
    Views: '-views',
    Id2: 'id',
    LastModified2: 'last_modified',
    Mitcoursenumber2: 'mitcoursenumber',
    New: 'new',
    ReadableId2: 'readable_id',
    StartDate2: 'start_date',
    Upcoming: 'upcoming',
    Views2: 'views'
};
//# sourceMappingURL=api.js.map